/* eslint-disable no-template-curly-in-string */
export default {
  featured: 'Избранное',
  popular: 'Популярные',
  couponsAndDeals: 'Купоны и предложения',
  yourFavorites: 'Ваше избранные',
  coupons: 'Купоны',
  headerCoupons: 'Karma | Купоны',
  lastSaved: 'Последнее сохраненное',
  favorites: 'Избранное',
  trending: 'Набирает популярность',
  weAreLoving: 'Мы любим',
  karmaHome: 'Karma | Главная',
  goodMorning: 'Доброе утро',
  goodAfternoon: 'Добрый день',
  goodEvening: 'Добрый вечер',
  addFavoriteStores: 'Добавить избранные магазины',
  nothingFound: 'Ничего не найдено',
  number: '{{value, number}}',
  clearNumber: '{{value, clearNumber}}',
  saveSettings: 'Сохранить настройки',
  enableBrand: 'Включить {{name}}',
  chrome: 'Chrome',
  edge: 'Edge',
  firefox: 'Firefox',
  ie: 'Internet Explorer',
  oldEdge: 'Edge',
  opera: 'Opera',
  safari: 'Safari',
  remove: 'Удалить',
  sponsored: 'Спонсируется',
  seeAll: 'Смотреть все',
  favorite: 'Избранное',
  onSale: 'Распродажа',
  lowInStock: 'Запасы на исходе',
  backInStock: 'Снова в наличии',
  coupon: 'Купон',
  soldOut: 'Распродано',
  fulfilled: 'Выполнено',
  deal: 'Промо',
  price: '{{currency}}{{value, number(minimumFractionDigits: 2)}}',
  karmaStores: 'Магазины Cash Back',
  priceLeftToWithdraw: 'Накопите еще всего {{currency}}{{value, number}}, а затем выводите свои награды!',
  fullPrice: '{{currency}}{{value, number}}.{{fraction, fraction}}',
  fraction: '.{{value, fraction}}',
  pendingCash: 'Ожидающие наличные',
  payouts: 'Выплаты',
  connectWithPayPal: 'Подключиться с PayPal',
  selectCause: 'Выберите доброе дело',
  dayBetweenPayouts: 'Деньги можно вывести через {{count, number}} день после подтверждения покупки.',
  dayBetweenPayouts_plural: 'Деньги можно вывести через {{count, number}} дня (дней) после подтверждения покупки.',
  list: 'Список:',
  emptyWallet: 'Ваш кошелек пуст',
  startShoppingToEarn: 'Начните покупать, чтобы заработать бонусы!',
  withdraw: 'Вывести',
  yourDonations: 'Ваши пожертвования',
  outOfAmount: 'Из {{currency}}{{value, number}}',
  gettingCloser: 'Вы все ближе!',
  canWithdrawEarnings: 'Вы уже можете вывести свой заработок.',
  workedAt: 'Работал(-а) {{date}}',
  copied: 'Скопирован!',
  getCoupon: 'Получить купон',
  shopNow: 'Купить сейчас',
  karmaLogo: 'Логотип Karma',
  myItems: 'Мои товары',
  stores: 'Магазины',
  myLists: 'Мои списки',
  uppercase: '{{text, uppercase}}',
  capitalize: '{{text, capitalize}}',
  all: 'Все',
  lastWeek: 'Прошлая неделя',
  lastMonth: 'Прошлый месяц',
  lastThreeMonths: 'Последние 3 месяца',
  clickID: 'Click ID',
  date: 'Дата',
  time: 'Время',
  retailer: 'Ритейлер',
  orderID: 'Ид. заказа',
  startShoppingToEarnKarmaCash: 'Начните покупать сейчас, чтобы заработать Cash Back,',
  browseStores: 'просмотрите магазины',
  doNotHaveClicks: 'У вас нет кликов в этот период.',
  doNotHaveTransactions: 'У вас нет транзакций в этот период.',
  payPalAlt: 'PayPal',
  payPal: 'PayPal:',
  welcomeBonus: 'Приветственный бонус!',
  karmaGives: 'Karma Gives!',
  karmaGivesRefund: 'Возврат Karma Gives!',
  completed: 'Завершено',
  notQualified: 'Не удовлетворяет требованиям',
  pending: 'В ожидании',
  cancelled: 'Отменен',
  paid: 'Оплачен',
  empty: 'Пусто',
  expired: 'Срок истек',
  discoverAndShop: 'Найти и купить',
  contactUs: 'Наши контакты',
  news: 'Новости',
  faq: 'Вопросы и ответы',
  aboutUs: 'О нас',
  karmaItem: 'Товар Karma',
  email: 'Эл. почта',
  congrats: 'Поздравляем!',
  getKarmaButton: 'Получите кнопку Karma!',
  saveThingsToBuy: 'Сохраняйте на потом товары, которые хотите купить, с Karma!',
  savedFirstItem: 'Вы сохранили свой первый товар!',
  getTheButton: 'Получить кнопку',
  savedFirstItem_plural: 'Вы уже сохранили несколько товаров!',
  iWantToSeeOther: 'Я хочу увидеть другие <1>поддерживаемые магазины',
  neverMissProducts: 'Никогда не пропускайте момент, когда товары поступят в продажу или снова появятся на складе!',
  shareByEmail: 'Поделиться по эл. почте',
  whenIFindSmth: 'Когда я нахожу что-то, что я хочу, я сохраняю это в Karma!',
  completeSignUp: 'Завершите регистрацию',
  addToList: 'Добавить в список',
  chat: 'Чат',
  karmaCash: 'Cash Back',
  clickToSaveItem: 'Нажмите для сохранения товара',
  createListAndPressEnter: 'Создайте список и нажмите «Ввод»',
  confirmDeleteProduct: 'Вы уверены, что хотите удалить этот продукт?',
  shareOnFacebook: 'Поделиться на Facebook',
  selectAll: 'Выбрать все',
  selectProp: 'Выберите {{name}}',
  delete: 'Удалить',
  fulfill: 'Выполнить',
  mute: 'Отключить звук',
  anyPriceChange: 'Любое изменение цены',
  priceOff: '{{value, number}}% скидки',
  notifyWhen: 'Уведомить, когда',
  tweetOnTwitter: 'Твит на Twitter',
  shareProduct: 'Поделиться продуктом',
  markAsFulfilled: 'Отметить как выполненное',
  unmuteNotifications: 'Включить звук уведомлений',
  muteNotifications: 'Отключить звук уведомлений',
  priceEvolution: 'Изменение цены',
  logOut: 'Выйти',
  twitter: 'Twitter',
  facebook: 'Facebook',
  instagram: 'Instagram',
  whatsapp: 'WhatsApp',
  messenger: 'Messenger',
  privacyPolicy: 'Политикой конфиденциальности',
  accessibility: 'Доступность',
  confirmDelete: 'Уверены, что хотите удалить эти продукты?',
  termsAndConditions: 'Положения и условия',
  logosProvidedBy: 'Логотипы предоставлены {{name}}',
  copyright:
    'Авторское право © {{year, clearNumber}} компании Karma Shopping Ltd., ведущей деятельность под наименованием Karma. Все права защищены.',
  noNotifications: 'Нет уведомлений',
  clearAllNotifications: 'Удалить все уведомления',
  areYouSureRemoveNotifications: 'Уверены, что хотите удалить все уведомления?',
  deleteProducts: 'Удалить продукты',
  no: 'Нет',
  yes: 'Да',
  headerStores: 'Karma | Магазины',
  clearNotification: 'Удалить уведомление',
  clear: 'Очистить',
  bell: 'колокольчик',
  remindInMinute: 'Напомнить мне через {{value, number}} минуту',
  remindInMinute_plural: 'Напомнить мне через {{value, number}} минут(-ы)',
  remindInHour: 'Напомнить мне через {{value, number}} час',
  remindInHour_plural: 'Напомнить мне через {{value, number}} часа(-ов)',
  retailers: 'Ритейлеры',
  claimKarmaCash: 'Получите до {{percent, number}}% Cash Back',
  clickOnClaimButton: 'Нажмите на кнопку «Получите до {{percent, number}}% Cash Back».',
  goShopping: 'Отправиться за покупками',
  rackUpCash: 'Накопить наличные',
  getPaidDirectly: 'Получайте оплату напрямую',
  earnRealMoney: 'Зарабатывайте реальные деньги буквально с каждой покупки.',
  trackYourEarnings: 'Отслеживайте свои доходы и выводите деньги каждый сезон.',
  ordinalNumber: '{{value, fraction}}',
  relatedStores: 'Связанные магазины',
  defaultWhatHappensNext:
    'Чтобы автоматически заработать Cash Back при следующей покупке, нажмите на одного из наших удовлетворяющих требованиям Cash Back продавцов на Karma, у которого вы можете делать покупки как обычно! Помните, что вы можете заработать Cash Back, только посетив подходящего продавца в приложении или на панели управления Karma (включая push-уведомления) или взаимодействуя с расширением браузера Karma на персональном компьютере/мобильном устройстве перед покупкой. Как только продавец проверит вашу покупку, Karma подтвердит зачисление вашего дохода в кошелек Karma.',
  defaultTermsAndConditions:
    'Cash Back недоступны при покупке подарочных сертификатов или оплаты любой части покупки с помощью подарочного сертификата, кредита магазина, баллов лояльности или другой программы, предусматривающей начисление баллов. Использование промокодов, не указанных на сайте Karma, может привести к аннулированию Cash Back. Дополнительные ограничения могут применяться к определенным товарам или категориям.',
  whatHappensNext: 'Что будет дальше?',
  about: 'О нас',
  readMore: 'Подробнее',
  frequentlyAskedQuestions: 'Вопросы и ответы',
  loadMore: 'Загрузить еще',
  questionButton: 'кнопка вопроса',
  headerKarmaCash: 'Karma | Денежные бонусы',
  recommended: 'Рекомендуется',
  highToLow: 'От высоких до низких',
  lowToHigh: 'От низких до высоких',
  sortBy: 'Сортировать по:',
  exploreStores: 'Обзор магазинов',
  weHaveNotFoundStores: 'Мы не нашли ни одного магазина по вашим запросам',
  weHaveNotFoundCoupons: 'Мы не нашли ни одного купона по вашим запросам',
  headerApps: 'Karma | Приложения',
  karmaApps: 'Получайте хорошую карму повсюду.',
  stayUpdated:
    'Будьте в курсе новостей на всех своих устройствах. Наш цифровой помощник по покупкам позволяет сохранять товары из более чем {{number, number}} тыс. магазинов.',
  getFaster: 'Сделайте взаимодействие более быстрым и плавным, загрузив Karma на свой Mac.',
  headerProfile: 'Karma | Профиль',
  headerWallet: 'Karma | Кошелек',
  totalBalance: 'Общий остаток',
  emailAddress: 'Адрес эл. почты',
  enterEmailAddress: 'Введите адрес эл. почты',
  enterEmail: 'Укажите эл. почту',
  enterEmailLower: 'Укажите эл. почту',
  phoneNumber: 'Номер телефона',
  enterPhoneNumber: 'Укажите номер телефона',
  fullName: 'Имя и фамилия',
  enterFullName: 'Введите имя и фамилию',
  enterPlaceholder: 'Укажите {{name}}',
  birthday: 'День рождения',
  year: 'Год',
  month: 'Месяц',
  day: 'День',
  gender: 'Пол',
  language: 'Язык',
  currency: 'Валюта',
  multiCurrency: 'Мультивалюта',
  male: 'Мужчина',
  female: 'Женщина',
  notWantShare: 'Я не хочу сообщать',
  mobilePush: 'Мобильное push-сообщение',
  webPush: 'Веб-push',
  disconnectFromPayPal: 'Отключить от PayPal',
  loginAsUser: 'FUT',
  selectYearAndMonth: 'Сначала выберите год и месяц',
  notSureWhereToStart: 'Не знаете, с чего начать?',
  youDidntSaveItems: 'У вас пока нет сохраненных товаров.',
  searchItems: 'Поиск товаров',
  headerDashboard: 'Karma | Панель управления',
  headerSales: 'Karma | Распродажи',
  couldNotFindStores: 'Ой, мы не смогли найти распродажи',
  karmaGivesValue: '{{value, number}} $',
  karmaGivesModalTitle: 'Вот вам {{value, number}} $ БЕСПЛАТНО для начала',
  hereIsABitOfGoodKarma: 'Вот немного хорошей кармы за регистрацию у нас!',
  collectAndStartSaving: 'Получите и начните экономить',
  termsAndConditionsAppersant: 'Положения и условия',
  mayApply: 'могут применяться',
  termsAndConditionsError: 'Сначала согласитесь с нашими условиям и политикой конфиденциальности.',
  validEmailError: 'Введите действительную эл. почту.',
  completeSignUpCapital: 'Завершите регистрацию',
  or: 'ИЛИ',
  password: 'Пароль',
  joinUs: 'Зарегистрируйтесь у нас',
  reviewsPlus: 'Более {{amount, number}} тыс. отзывов',
  logIn: 'Вход',
  termsAgreement: 'Зарегистрировавшись, вы соглашаетесь с нашими <1>Условиями и <3>Политикой конфиденциальности',
  termsAgreementWithCheckbox: 'Я соглашаюсь с <1>Положениями и условиями и <3>Политикой конфиденциальности',
  createANewList: 'Создать новый список',
  listCreateBlickError: 'Имя списка не может быть пустым',
  enterListName: 'Укажите название списка',
  listDescriptionOptional: 'Описание списка (необязательно)',
  listName: 'Название списка',
  enterDescriptionForList: 'Введите описание вашего списка',
  save: 'Сохранить',
  deleteList: 'Удалить список',
  areYouSureRemoveList: 'Вы действительно хотите удалить этот список?',
  editList: 'Редактировать список',
  listNameCanNotBeBlanck: 'Имя списка не может быть пустым',
  shareList: 'Поделиться списком',
  notAMemberCreateAccount: 'Не зарегистрированы? <1>Создайте аккаунт!',
  backToLogin: 'Назад ко входу',
  enterYourEmail: 'Введите свой адрес эл. почты',
  resetPassword: 'Сбросить пароль',
  forgotPasswordMessage:
    'Через несколько минут вы получите электронное письмо с инструкциями по восстановлению пароля.',
  forgotPassword: 'Забыли пароль?',
  pleaseScan: 'Пожалуйста, отсканируйте',
  saveAnItem: 'Сохранить товар',
  areYouSureFulfilled: 'Уверены, что хотите пометить все заказы на эти товары как выполненные?',
  muteTagDesc: 'Уверены, что хотите отключить звук уведомлений об этих товарах?',
  muteTagTitle: 'Отключить звук уведомлений',
  ok: 'ОК',
  ccpaTitle:
    'Закон штата Калифорния о конфиденциальности потребителей (CCPA) с поправками, внесенными Законом штата Калифорния о правах на конфиденциальность (CPRA)',
  ccpaText: ' Отправляя эту форму, я использую свое право отказаться от любой продажи моей личной информации.',
  submit: 'Отправить',
  joinKarmaAndGetRewards: 'Присоединяйтесь к Karma и получайте бонусы {{stack, number}} в {{name}}',
  doNotMissOut: 'Не пропустите! Возможно, вы сможете сэкономить на покупке товара!',
  signUpAndGetMoney: 'Зарегистрируйтесь и получите {{value, number}} $',
  itemAlert: 'Получено оповещение о товаре!',
  accessKarmaCash: 'Доступ к вашим Cash Back',
  youEarnedKarmaCash: 'Вы только что заработали Cash Back!',
  weHaveSentAnEmailTo: 'Мы отправили письмо на {email}',
  installed: 'Установлен',
  comingSoon: 'Скоро появится',
  'Fall Favorites': 'Популярное осенью',
  'Karma Cash': 'Cash Back',
  'Clothing & Luxury': 'Одежда и роскошь',
  'Home Decor & Furniture': 'Домашний декор и мебель',
  'Electronics & Office Supplies': 'Электроника и канцелярские товары',
  Luxury: 'Роскошь',
  Clothing: 'Одежда ',
  'Handbags & Shoes': 'Сумки и обувь',
  'Jewelry & Watches': 'Ювелирные изделия и наручные часы',
  Accessories: 'Аксессуары',
  'Beauty Essentials': 'Базовая косметика',
  'Health & Wellness': 'Здоровье и велнес',
  Lifestyle: 'Образ жизни',
  'Sports & Outdoors': 'Спорт и туризм',
  Travel: 'Путешествия',
  'Electronics & Office supplies': 'Электроника и канцелярские товары',
  'Entertainment & Online Services': 'Развлечения и онлайн-услуги',
  Education: 'Образование',
  'Finance & FinTech': 'Финансы и финтех',
  'Pet Supplies': 'Товары для питомцев',
  'Food & Beverages': 'Еда и напитки',
  Men: 'Мужчины',
  Women: 'Женщины',
  Unisex: 'Унисекс',
  Kids: 'Дети',
  Baby: 'Малыш',
  notifications: 'Уведомления',
  changesSaved: 'Изменения сохранены!',
  headerRetailer: 'Karma | Ритейлер',
  headerRedirect: 'Karma | Перенаправление...',
  karma: 'Karma',
  goBackToKarma: 'Назад в Karma',
  authentication: 'Аутентификация',
  authSuccess: 'Поздравляем! Вы успешно вошли.',
  authFailure: 'Ой, мы не смогли авторизовать вас. Попробуйте позже.',
  mayNotQualify: 'Некоторые товары могут не предоставлять право на Cash Back',
  checkOutRetailers: 'Посмотрите поддерживаемых нами ритейлеров Cash Back.',
  headerHowItWorks: 'Karma | Как это работает',
  accept: 'Принять',
  headerError: 'Karma | Ошибка',
  pageNotFound: 'Страница не найдена',
  pageDoesNotExist: 'Ой, похоже, этой страницы не существует.',
  backHome: 'Назад на главную',
  startShopping: 'Начать покупки',
  illustration: 'Иллюстрация',
  dashboard: 'Панель управления',
  allRightsReserved: 'Все права защищены.',
  product: 'Товар',
  disclaimer:
    'Компания Karma Shopping Ltd. ведет деятельность под названием Karma. Karma не владеет сторонними товарными знаками и не претендует на них. Сторонние товарные знаки, отображаемые на платформе Karma или доступные прямо или косвенно через нее, не обязательно имеют отношение к Karma, третьим сторонам, связанными с Karma, или поставщиками услуг Karma.',
  help: 'Справка',
  team: 'Команда',
  howItWorks: 'Как это работает',
  supportedStores: 'Поддерживаемые магазины',
  company: 'Компания',
  planYourPurchase: 'Спланируйте следующую покупку в нашем бесплатном приложении!',
  itSitsInBrowser: 'Она отображается в вашем браузере, когда вы посещаете все любимые магазины.',
  seeSmthYouLike:
    'Вам что-то понравилось? Нажмите кнопку и сохраните товар в своем списке, и Karma будет следить за его ценой и наличием вместо вас.',
  youWillGetNotified:
    'Вы сразу же получите уведомление, как только ваши сохраненные товары поступят в продажу, подешевеют или снова появятся на складе в выбранном вами размере и цвете.',
  everythingYouWant:
    'Все, что вы хотите купить, будет в одном удобном месте, чтобы у вас все было упорядочено и не нужно было тасовать несколько списков пожеланий.',
  headerContactUs: 'Karma | Наши контакты',
  needToGetInTouch: 'Нужно связаться?',
  dropALine: 'Напишите нам',
  comeHangOut: 'Давайте потусуемся',
  joinOurFacebookCommunity: 'Присоединяйтесь к нашему сообществу на Facebook',
  followOnInstagram: 'Подпишись на нас в Instagram',
  headerAboutUs: 'Karma | О нас',
  addTheItems:
    'Добавляйте товары, которые хотите купить, — вы также можете указать их размер и цвет, и приложение уведомит вас, когда они появятся в продаже.',
  jonathanSay:
    'Джонатан: хотя ритейлеры уже много лет используют искусственный интеллект, теперь потребители смогут с выгодой воспользоваться инструментами машинного обучения и автоматизации для повышения эффективности покупок.',
  justDownload:
    'Просто скачайте «кнопку» и нажмите ее, когда вы выберете товар, который хотите сохранить в своем списке. На мобильном устройстве вы можете «делиться» товарами, отправляя их в же списки.',
  ifYouFind:
    'Если вы найдете в Интернете понравившийся вам товар, который выходит за рамки вашего бюджета, вы можете настроить оповещение о распродаже и получать уведомления о снижении цены на него.',
  onlyAHandful:
    'Лишь немногие компаний, предлагающих уведомления о распродажах для онлайн-участников, все еще продолжают работу. К их числу относится Karma.',
  alwaysBuy: 'Всегда покупайте что-нибудь на распродаже с Karma.',
  headerCareers: 'Karma | Карьера',
  getInTouch: 'Свяжитесь с нами:',
  shop: 'Делайте покупки',
  weCouldNotFindResults: "Не смогли найти результатов для '{{name}}'",
  couldNotFindResults: 'Мы не смогли найти результаты',
  shopAllStores: 'Покупайте во всех поддерживаемых магазинах',
  popularStores: 'Популярные магазины',
  shops: 'Магазины',
  headerDiscoverAndShop: 'Karma | Находите и покупайте последние сохраненные товары',
  prev: 'Пред.',
  next: 'Далее',
  headerDemo: 'Karma | Демо',
  getTheKarmaButton: 'Получить кнопку Karma',
  installedKarma: 'Вы успешно установили Karma!',
  settingUpAccount: 'Теперь давайте создадим аккаунт.',
  signUpNow: 'Зарегистрироваться сейчас',
  logInNow: 'Войти',
  signUpLater: 'Зарегистрироваться позже',
  wePartnerWith: 'Мы сотрудничаем с более чем {{number, number}} тыс. интернет-магазинов!',
  pickStoresToSee: 'Выберите один из магазинов ниже, чтобы увидеть, как это работает:',
  leaveKarma:
    'Обратите внимание, что вы покинете Karma и перейдете на страницу магазина, чтобы воспользоваться всеми функциями.',
  searchFavoriteStores: 'Поиск в любимых магазинах',
  clickBelowToStart: 'Нажмите ниже, чтобы начать',
  chooseOneOfTheOptions: 'Выберите один из вариантов ниже',
  clickToBegin: 'Нажмите на панель поиска, чтобы начать',
  preferNotToSay: 'Предпочитаю не отвечать',
  done: 'Готово',
  headerUnsubscribe: 'Karma | Отписаться',
  changeMind: 'Передумали?',
  resubscribeList: 'Снова подпишитесь на вашу рассылку.',
  resubscribeList_plural: 'Подпишитесь на свою рассылку здесь.',
  changePreferencesAtAnyTime: 'Вы также можете изменить свои предпочтения в любое время в <1>настройках аккаунта.</1>',
  preferencesUpdated: 'Мы обновили настройки коммуникаций по эл. почте.',
  sorryToSeeYouGo: 'Нам жаль, что вы уходите!',
  reSubscribed: 'Вы переподписались',
  allowHours: 'Изменения вступят в силу не позже чем через {{hours, number}} часа(-ов).',
  missWhenYouGone:
    'Мы будем скучать по вам после вашего ухода! Изменения вступят в силу не позже чем через {{hours, number}} часа(-ов).',
  headerDisablingSubscribe: 'Karma | Отказ от подписки',
  noLongerAlerts: 'Вы больше не будете получать оповещения об этом товаре.',
  turnAlertsBack: 'Снова включить оповещения.',
  moveAnimations: 'Переместить анимацию кнопки',
  headerExtensionDeleted: 'Karma | Расширение удалено',
  areSorryToSeeYouGo: 'Нам жаль, что вы уходите!',
  youHaveGotInYourWallet: 'У вас в кошельке {{value}} $.',
  toWithdraw: ' чтобы вывести свой заработок!',
  toContinue: ' чтобы и дальше получать бонусы!',
  reasonUninstalled: 'Сообщите нам, почему вы удалили:',
  getInTouchBtn: 'Свяжитесь с нами',
  howWeCanIncrease: 'Вот как вы можете повысить осведомленность и увеличить продажи с помощью рекламы с Karma',
  helpingShoppers:
    'Помогать покупателям открывать для себя бренды, которые они полюбят на долгие годы, — один из наших главных приоритетов как личного помощника по покупкам.',
  whyWeOfferBrands:
    'Вот почему мы предлагаем брендам, которые неизменно обеспечивают высокий уровень удовлетворенности клиентов, несколько способов связи с нашей аудиторией. Вы достигнете целей своей кампании, а наша аудитория познакомится со своим новым любимым брендом.',
  winWin:
    'Мы предлагаем брендам, которые неизменно обеспечивают высокий уровень удовлетворенности клиентов, несколько способов связи с нашей аудиторией. Вы достигнете целей своей кампании, а наша аудитория познакомится со своим новым любимым брендом — это поистине выгодно всем сторонам!',
  getFeaturedRight: 'Попадите в избранное прямо в нашем приложении и панели управлении расширением браузера',
  getFeaturedDashboard: 'Попадите в избранное на панели инструментов Karma',
  putYourHand:
    'Поместите свой образ, товары или промоакции именно туда, куда приходят наши пользователи, когда готовы к покупкам. Мы можем создать разнообразный индивидуальный брендированный контент, который будет привлекать трафик заинтересованных покупателей, куда бы вы ни хотели его направить.',
  exactPlace:
    'Поместите свой бренд именно в то место, куда приходят наши пользователи, когда готовы совершить покупку.',
  dedicatedInAppPlacement: 'Выделенное место в приложении',
  dashboardFeaturedBanners: 'Баннеры избранного на панели управления',
  dashboardPopUpMessages: 'Всплывающие сообщения в панели управления',
  customEmailsAndNewsLetters:
    'Персонализированные письма и включение в рассылку с боле чем {{subscribers, number}} адресатов',
  customEmails: 'Персонализированные письма более чем {{subscribers, number}} подписчикам',
  getMoreEyes:
    'Привлеките большее внимание к своему последнему предложению, коду купона или линейке продуктов с помощью специального электронного письма или рассылки покупателям.',
  putYourBrand:
    'Поместите свой бренд именно в то место, куда приходят наши пользователи, когда готовы совершить покупку.',
  newsletterInclusion: 'Включение в рассылку',
  dedicatedCustomEmails: '{{percent, number}}% специальных настраиваемых писем',
  bannerPlacementInEmails: 'Размещение баннера в письмах с уведомлениями',
  pushNotificationsToShoppers: 'Push-уведомления в адрес более чем {{shoppers, number}} покупателей',
  pushNotificationsGiveTouchPoint:
    'Push-уведомления предоставляют вашей кампании еще одну точку соприкосновения с аудиторией и обеспечивают высокие показатели открытия и кликов.',
  featureBrandClients: 'Избранные клиенты бренда',
  growingPerMonth: 'Рост более чем на {{number, number}} тыс. в месяц',
  members: 'Участники',
  percent: '{{value, number}}%',
  kindOfReachYouExpect: 'Какого охвата вы ожидаете?',
  ourAudience: 'Наша аудитория',
  tabIntoNewSource: 'Найдите новый источник подходящих клиентов для следующей кампании',
  tellUsAboutYourCompany:
    'Расскажите нам немного о своей компании и целях, и мы покажем вам, как мы можем помочь вам превзойти их.',
  openAndTap:
    'Откройте Safari, перейдите на страницу товара, который хотите сохранить, и нажмите кнопку «Поделиться» (Share).',
  shareIllustration: 'Поделиться иллюстрацией',
  tapMore: 'Нажмите кнопку «Еще» (More) в правой части панели.',
  moreIllustration: 'Еще иллюстрация',
  enableIllustration: 'Включить иллюстрацию',
  tapEdit: 'Нажмите на кнопку «Изменить» (Edit) в верхней части панели.',
  enableApp:
    'Включите Karma и нажмите на зеленую кнопку «добавить» (add), чтобы добавить товар в избранное, а затем нажмите на «Готово» (Done).',
  goBackToTheProduct:
    'Вернитесь на страницу товара, снова нажмите кнопку «Поделиться» (Share), а затем на кнопку Karma, чтобы сохранить товар.',
  recommendedBy: 'Рекомендуется',
  ourMembersSavingMoney: 'Наши покупатели ❤️ экономят с Karma. Вот почему',
  ourMembersSavingMoney2: 'Наши покупатели <1/> экономят с Karma. Вот почему',
  addToBrowser: 'Добавьте в {{browser}} — это бесплатно',
  planPurchases: 'Спланируйте очередные покупки',
  karmaMakesItEasy: 'Karma позволяет легко упорядочить ваши очередные покупки в одном месте.',
  buyAtRightTime: 'Покупайте в нужное время',
  automaticallyAlert: 'Karma автоматически оповестит вас о лучшем времени для покупки!',
  cashOnVacation: 'Cash Back для следующего отпуска',
  karmaPartners: 'Karma сотрудничает со многими туристическими и гостиничными сайтами.',
  headerRewards: 'Karma | Лучшие купоны и денежные бонусы',
  mission: 'Наша миссия',
  empowerYou:
    'Мы предоставляем вам возможность делать правильный выбор в нужное время при совершении покупок в Интернете.',
  weAreSeriousAboutPrivacy: 'Мы серьезно относимся к вашей конфиденциальности и безопасности',
  weDoNotSellData: 'Мы не продаем ваши данные',
  karmaIsSerious: 'Karma очень серьезно относится к вашим данным и никогда не продает их третьим лицам. Никогда.',
  karmaIsSecure: 'Karma безопасна',
  weUseBankSecurity:
    'Мы используем средства безопасности банковского уровня ({{bit, number}}-битовое шифрование), чтобы гарантировать безопасность и надежную защиту вашей информации.',
  helpsSaveMore: 'Karma помогает вам больше экономить!',
  alertMe: 'Оповещения',
  buyWithKarmaEarn: 'Покупайте с Karma — зарабатывайте {{number, number}} $',
  productSaved:
    'Поздравляем! Этот товар сохранен в вашем списке товаров. Вы получите уведомление, когда он подешевеет.',
  willApplyTheBestCoupons: 'Karma автоматически применит лучшие купоны к вашей покупке!',
  downloadAndAutoApply: 'Скачайте Karma и применяйте автоматически',
  whatIsKarma: 'Что такое Karma?',
  claimUpToRewards: 'Получите до {{number, number}}% денежного бонуса',
  youMightAlsoLike: 'Вам также может понравиться',
  weAreSorry: 'Сожалеем, но что-то пошло не так, и не удается показать страницу.',
  tryToReloadPage: 'Попробуйте перезагрузить страницу.',
  Color: 'Цвет',
  Size: 'Размер',
  latestCoupons: '{{name}} | Последние купоны и кешбэк Karma {{year, clearNumber}}',
  neverPayFullPrice: "Никогда не платите полную цену. Получите купоны и кешбэк Karma's {{name}}",
  neverPayFullPriceForTag: 'Никогда не платите полную цену за {{name}}',
  saveMoneyWhenShoppingAt: 'Экономьте деньги, делая покупки в {{name}}. Регистрируйтесь в Karma бесплатно',
  saveMoneyWhenShoppingFor: 'Экономьте деньги, покупая {{name}}. Регистрируйтесь в Karma бесплатно',
  tagByBrand: 'Karma | {{tag}} от {{brand}}',
  typeToSearch: 'Введите текст для поиска',
  getUSDWhenJoinToday: 'Получите {{value, number}} $ за регистрацию в Karma сегодня!',
  buyProduct: 'Купить товар',
  userWishList: 'Karma | Список пожеланий {{name}}',
  byWhom: 'от',
  copiedToClipboard: 'Скопировано в буфер обмена!',
  send: 'Отправить',
  cause: 'Выберите доброе дело:',
  aCause: 'Выберите доброе дело:',
  close: 'Закрыть',
  selectThisCause: 'Выбрать доброе дело',
  habitatForHumanity:
    '{{name}} занимается сокращением бедности в долгосрочной перспективе с помощью доступного социального жилья. Миссия организации — создать безопасную среду, в которой могут процветать семьи и сообщества.',
  casaDescription:
    'Национальная ассоциация CASA/GAL поддерживает назначенных судом волонтеров-адвокатов и содействует такой работы, чтобы каждый ребенок, подвергшийся жестокому обращению или оставленный без внимания, был в безопасности, имел постоянный дом и преуспел в жизни.',
  endHomelessnessDescription:
    'Национальный альянс {{name}} — это независимая организация, занимающаяся профилактикой бездомности в Соединенных Штатах Америки и стремящаяся положить ей конец.',
  pathDescription: 'PATH борется с бездомностью отдельных лиц, семей и сообществ.',
  feedingAmericaDescription: 'Feeding America — крупнейшая национальная организация по борьбе с голодом.',
  mealsOnWheelsDescription:
    '{{name}} помогает местным общественным программам улучшать здоровье и качество жизни пожилых людей, которым они служат, чтобы никто не остался голодным или одиноким.',
  actionAgainstHunger:
    '{{name}} — глобальная гуманитарная организация, которая принимает решительные меры против причин и последствий голода.',
  supportMedicalAdvancement: 'Поддерживайте развитие медицины',
  saveChildsHeartDescription:
    "Save A Child's Heart занимается лечением болезней сердца независимо от расы, религии, пола, национальности или финансового положения.",
  su2c: 'Stand Up To Cancer (SU2C) финансирует и разрабатывает новейшие и наиболее многообещающие методы лечения рака, чтобы помочь пациентам сегодня.',
  drWithoutBorders:
    '{{name}} — это независимое глобальное движение, оказывающее медицинскую помощь там, где она больше всего нужна.',
  activeMinds:
    '{{name}} — ведущая некоммерческая организация страны, поддерживающая осведомленность о психическом здоровье и просвещение молодежи.',
  cleanAirTaskForceDesc:
    '{{name}} содействует изменениям в технологиях и политике, необходимым для достижения нулевых выбросов на планете и высокому энергопотреблению по доступной цене.',
  wwfDesc: 'Миссия {{name}} — сохранить природу и уменьшить самые серьезные угрозы разнообразию жизни на Земле.',
  waterkeepsDesc:
    '{{name}} борется за чистоту воду. Waterkeeper Alliance стремиться обеспечить каждому сообществу в мире наличие питьевой, пригодной для рыбной ловли и купания воды.',
  xprice:
    'Каждый день XPrize трудится над созданием лучшего мира, в котором каждый человек имеет доступ к чистой воде, питательной пище, доступному жилью, эффективному обучению, высококлассному медицинскому обслуживанию и экологически чистым источникам энергии.',
  globalActDesc: '{{name}} стремится положить конец сексуальной и коммерческой эксплуатации.',
  pcaa: '{{name}} прилагает все усилия, чтобы воплотить в жизнь наше видение мира, в котором все дети растут счастливыми, здоровыми и способными добиться успеха в семьях и сообществах, где их поддерживают.',
  endCAN:
    'EndCAN повышает осведомленность о воздействии жестокого обращения на здоровье, психическое здоровье и общественное здоровье, стремясь положить конец жестокому обращению с детьми и оставлению их без внимания.',
  futuresDesc:
    'FUTURES предлагает новаторские программы, стратегии и кампании, которые расширяют возможности отдельных лиц и организаций, работающих над прекращением насилия в отношении женщин и детей во всем мире.',
  thornDesc: '{{name} создает технологии для защиты детей от сексуального насилия.',
  'Eradicate Homelessness': 'Искореняйте бездомность',
  'Help End Hunger': 'Помогите ликвидировать голод',
  'Support Medical Advancement': 'Поддерживайте развитие медицины',
  'Combat Climate Change': 'Боритесь с изменением климата',
  'Act To End Abuse': 'Помогите прекратить насилие',
  itemsYouSaved: 'Товары, которые вы сохранили, по более доступной цене',
  beta: 'БЕТА-ВЕРСИЯ',
  alsoAvailableAt: 'Также доступно в',
  atName: 'у {{name}}',
  bestPrice: 'Лучшая цена',
  passwordWasSuccessfullyReset: 'Пароль успешно сброшен',
  paidWith: 'Оплачено с помощью',
  infoFirstNumber: 'Более {{number, number}}{{unit}}',
  infoFirstTitle: 'Участников',
  infoSecondNumber: 'Более {{number, number}}{{unit}}',
  infoSecondTitle: 'Ежемесячных визитов',
  infoThirdNumber: 'Более {{number, number}}{{unit}}',
  infoThirdTitle: 'Адресатов рассылки',
  infoFourthNumber: '{{value, number}}%',
  infoFourthTitle: 'Миллениала(-ов)',
  infoFifthNumber: '{{value, number}}%',
  infoFifthTitle: 'Женщин',
  infoSixthNumber: '{{value, number}}%',
  infoSixthTitle: 'Расположенны в США',
  infoSeventhNumber: 'Более {{number, number}}{{unit}}',
  infoSeventhTitle: 'Согласий с push-уведомлениями на мобильные устройства',
  infoEighthNumber: 'Более {{number, number}}{{unit}}',
  infoNinthPreNumber: '',
  infoNinthNumber: 'Более {{number, number}}{{unit}}$',
  infoNinthTitle: 'Будет потрачено пользователями до конца {{year, clearNumber}}',
  karmaIsAlwaysWithYou: 'Karma всегда с вами, когда вы делаете покупки',
  saveItemsToBuy: 'Сохраняйте товары, и мы сообщим вам, когда покупать',
  weDoTheWork: 'Мы делаем все возможное, чтобы найти вам лучшие купоны',
  earnRealCashThatAdds: 'Зарабатывайте реальные деньги, которые накапливаются в вашем кошельке',
  setUpStrongPassword: 'Задайте надежный пароль',
  settingEmailAccount:
    'Последний шаг к экономии с Karma? Зарегистрируйтесь, чтобы мы могли отправлять вам важные оповещения о товарах, например, о снижении цен.',
  settingPasswordAccount:
    'Пароль должен состоять как минимум из {{number, number}} символов и не должен включать ваши учетные данные электронной почты.',
  countWaysToUse: '{{number, number}} способа(-ов) использовать Karma',
  goBack: 'Назад',
  pleaseChooseStrongerPassword: 'Выберите более надежный пароль',
  pleaseEnterValidEmailAddress: 'Введите действительный адрес эл. почты',
  illSignUpLater: 'Я зарегистрируюсь позже',
  joinOur1MEarningUsers: 'Join our 1M earning users',
  enterYourEmailAddress: 'Введите свой адрес эл. почты, и мы отправим вам ссылку для сброса пароля.',
  headerOnboardingIosExtension: 'Karma | Расширение IOS для начала работы',
  weWillAutomaticallyApplyCouponsWhereverYouShop: 'Мы автоматически применим купоны, где бы вы ни покупали',
  continue: 'Продолжить',
  changeLanguage: 'Изменить язык',
  selectedLanguage: 'Выбранный язык',
  headerMuteItem: 'Karma | Не уведомлять о товаре',
  itemHasBeenMuted: 'Об этом товаре не будет уведомлений.',
  toUnmuteItem: 'Для включения уведомлений о товаре:',
  headToMyItems: 'Перейдите на вкладку «Мои товары»',
  openKarma: 'Открыть',
  clickThreeButtonsInItem: 'Нажмите на кнопку с тремя точками в правом нижнем углу товара"',
  clickUnmute: 'Нажмите на элемент, звук которого вы хотите включить.',
  changeNotification: 'Измените настройки уведомлений под ценой товара',
  weveJustRaisedInFunding:
    'Мы только что привлекли {{value, number}} млн $ на этапе финансирования A, чтобы помочь вам делать покупки умнее!',
  weveJustRaised: 'Мы привлекли {{value, number}} млн $',
  landingReview1: 'Отличное приложение! Я получил предложение о снижении цены и сэкономил много денег!',
  landingReview2: 'Оно сэкономило мне {{value, number}} $ при первой покупке. Это произвело сильное впечатление!',
  landingReview3: 'Это полезное приложение, мне очень нравятся уведомления и бонусы.',
  landingReview4: 'Мне еще предстоит попробовать беспроблемные покупки!',
  landingReview5: 'Я сэкономил {{value, number}}%! Иначе бы я не узнал о распродаже!',
  landingReview6: 'Легкое отслеживание любимых товаров... Настоятельно рекомендую...!',
  landingReviewAuthor1: 'Justin Nguyen',
  landingReviewAuthor2: 'Amy Ellis',
  landingReviewAuthor3: 'Maude Aethelredd',
  landingReviewAuthor4: 'Patrick Slocum',
  landingReviewAuthor5: 'Michelle Findley',
  landingReviewAuthor6: 'Varsha Hulekal',
  auxiliaryDate: '{{date}}',
  resetMyPassword: 'Сбросить мой пароль',
  repeatPassword: 'Повтор пароля',
  continueAsGuest: 'Продолжить в качестве гостя',
  viewAt: 'Посмотреть в {{- name}}',
  signUp: 'Зарегистрироваться',
  youMayAlsoLike: 'Вам также может понравиться',
  buyOnShop: 'Купить на',
  viewOn: 'Посмотреть на {{- name}}',
  quickView: 'Быстрый просмотр',
  newList: 'Новый список',
  undo: 'Отмена',
  productDeleted: 'Товар удален',
  linkCopiedToClipboard: 'ссылка скопирована в буфер обмена',
  wishlists: 'Списки пожеланий',
  headerPartnerships: 'Karma | Партнерства',
  letsJoinForces: 'Давайте объединим усилия',
  bePartOfTheSmartShoppingRevolution:
    'Станьте частью революции умных покупок. Мы познакомим с вашим брендом более {{number, number}} миллионов покупателей, готовых оформить заказ.',
  seeKarmaInAction: 'Посмотрите Karma в действии',
  discoverHowKarma:
    'Узнайте, как решения Karma на основе искусственного интеллекта и автоматизации улучшают весь процесс совершения покупок, привлекая целевой трафик к вашим предложениям.',
  stepUpYourSales: 'Наращивайте свои продажи',
  averageROAS: 'Средняя рентабельность<br/>затрат на рекламу',
  increaseInAOV: 'Увеличение средней<br/>суммы заказа',
  useKarmaToPlanTheirNextPurchase: 'Используйте Karma,<br/>чтобы спланировать их следующую покупку',
  meetOurShoppers: 'Познакомьтесь с нашими покупателями',
  meetOurShoppersDescription:
    'Воспользуйтесь нашими маркетинговыми решениями, ориентированными на эффективность, и произведите впечатление на покупателей, которые твердо намерены совершить покупку. Размещение нами рекламы на разных платформах позволяет вам обращаться к пользователям, где бы они ни находились.',
  audienceInfoFirstNumber: 'Более {{number, number}}{{unit}}',
  audienceInfoFirstTitle: 'пользователей',
  audienceInfoSecondNumber: 'Более {{number, number}}{{unit}}',
  audienceInfoSecondTitle: 'ежемесячных визитов',
  audienceInfoThirdNumber: 'Более {{number, number}}{{unit}}',
  audienceInfoThirdTitle: 'сохраненных товаров',
  audienceInfoFourthNumber: '{{value, number}}%',
  audienceInfoFourthTitle: 'пользователей в США',
  audienceInfoFifthNumber: '{{value, number}}%',
  audienceInfoFifthTitle: 'представителей поколения Z и миллениалы',
  audienceInfoSixthNumber: '{{value, number}}%',
  audienceInfoSixthTitle: 'женщин-покупателей',
  ourUsersLoveUs: 'Наши пользователи обожают нас!',
  partnershipsReview1:
    'Отличное расширение! Это отличное расширение, которое я использую в течение многих лет. Оно позволяет хранить множество товаров в одном месте. Это делает покупки в Интернете намного менее напряженными!',
  partnershipsReviewAuthor1: 'Милли Робинсон',
  partnershipsReview2:
    'Как человек, который ОЧЕНЬ МНОГО покупает в Интернете, я могу честно сказать, что Karma — лучший друг покупателей по многим причинам…',
  partnershipsReviewAuthor2: 'Сэди Мэй',
  partnershipsReview3:
    'Лучшее приложение для покупок в Play Store. Очень легкое в использовании. Все мои сохраненные товары из моих любимых магазинов в одном приложении! 👍🏻',
  partnershipsReviewAuthor3: 'Кимберли Роджерс',
  performanceBasis: 'На основе эффективности',
  fixedFee: 'Фиксированная плата',
  thanksForSubmitting: 'Спасибо за сообщение!',
  someoneFromOurPartnershipsTeamWillBeInTouchShortly:
    'Представитель нашей команды по работе с партнерами свяжется с вами в ближайшее время.',
  letsKickStartOurPartnership: 'Давайте станем партнерами!',
  emailOrPhoneNumber: 'Адрес эл. почты или номер телефона',
  retailerName: 'Имя/название розничного продавца',
  affiliateNetwork: 'Партнерская сеть',
  budgetStructure: 'Структура бюджета',
  budget: 'Бюджет',
  tellUsMore: 'Расскажите нам подробней',
  pleaseFillInAllRequiredFields: 'Заполните все обязательные поля',
  partnerships: 'Партнерства',
  weCannotSaveThisItem: 'Мы не можем сохранить этот товар,<1/> так как этот магазин не поддерживается.',
  theresCoupon: 'Есть купон!',
  yourItemIsOffWithCode: 'На ваш товар предоставляется скидка {{value, number}}% по коду {{code}} у {{- name}}',
  muteAllNotification: 'Отключить все уведомления',
  unMuteAllNotification: 'Включить все уведомления',
  notificationSettings: 'Настройки уведомлений',
  deleteNotification: 'Удалить уведомление',
  notificationDeleted: 'Уведомление удалено',
  itemMuted: 'Товар деактивирован',
  itemUnMuted: 'Товар активирован',
  priceDrop: 'Снижение цены',
  superDeal: '🔥 Супер сделка',
  notSureWhenToBuy: 'Не знаете, когда покупать? Создайте бесплатный аккаунт, и мы сообщим, когда начнется промоакция.',
  tcMayApply: 'Могут применяться условия и положения',
  earnKarmaCash: 'Заработайте до {{percent, number}}% Cash Back.',
  saveToKarma: 'Сохранить товар в Karma',
  getKarmaToTrackItem: 'Отслеживать товар с помощью Karma',
  itemSaved: 'Товар сохранен!',
  youCanNowFindItem: 'Теперь вы можете найти свой товар в Панели управления Karma.',
  getKarmaExtension: 'Получите расширение Karma, чтобы <1/>отслеживать эту необходимую вещь',
  notifyYou: 'Мы сообщим, когда наступит лучшее время для покупки!',
  downloadTheExtension: 'Скачать расширение',
  outOfStock: 'Нет в наличии',
  invalidEmailError: 'Неверный адрес электронной почты',
  collapse: 'Свернуть',
  expand: 'Развернуть',
  lists: 'Списки',
  organizeYourItemsIntoWishListsWithJustAClick: 'Расположите свои товары в списках желаний одним щелчком мыши.',
  newItem: 'Новый товар',
  helpCenter: 'Справочный центр',
  priceHighToLow: 'Цена от высокой к низкой',
  priceLowToHigh: 'Цена от низкой к высокой',
  sale: 'Распродажа',
  filterBy: 'Фильтровать по:',
  karmaExclusive: 'Эксклюзив K',
  noItemsFound: 'Товары не найдены',
  select: 'Выбрать',
  likeSneakersOrBlackFriday: 'Например, «Кроссовки» или «Черная пятница»',
  updateList: 'Обновить список',
  firstName: 'Имя, фамилия',
  lastName: 'Фамилия',
  enterFirstName: 'Введите имя',
  enterLastName: 'Введите фамилию',
  recentSearches: 'Недавние поисковые запросы',
  addYourFavoriteStores: 'Добавьте любимые магазины,',
  toAccessTheirLatestCoupons: 'чтобы получить доступ к своим последним купонам',
  logosProvidedByClearbit: 'Логотипы, предоставленные Clearbit',
  dateOfBirth: 'Дата рождения',
  weHaveEmailedYouALinkToResetYourPassword: 'Мы отправили вам ссылку для сброса пароля.',
  didNotGetIt: 'Не получили ее?',
  profile: 'Профиль',
  promotionsAndActivity: 'Промоакции и мероприятия',
  couponsForFavoriteStores: 'Купоны для любимых магазинов',
  accountActivity: 'Действия с аккаунтом',
  powerShopper: 'Вы продвинутый покупатель? 💪',
  enterLinkToAnyItemPage: 'Введите ссылку на любую страницу товара',
  saveStuffWithZeroFuss: '<0>Получите расширение браузера</0> и сохраняйте товары без хлопот.',
  viewMore: 'Смотреть еще',
  tooHotToMiss: 'Слишком горячо, чтобы пропустить',

  // WebsiteLandingKarmaOld
  joinShoppers: 'Присоединяйтесь к более чем {{number, number}} миллионам покупателей',
  waysToUse: 'Способы использования Karma',
  youCanUseKarma:
    'Вы можете использовать Karma по-разному, например, чтобы убедиться, что получаете лучшую цену в нужное время, а также для планирования очередных покупок. Вот некоторые примеры того, что мы рекомендуем:',
  livesInBrowser: 'Karma находится в браузере',
  browserExtension: 'Расширение для браузера Karma встретит вас повсюду, где вы совершаете покупки в Интернете.',
  helpsYouPlan: 'Помогает вам спланировать очередные покупки',
  notReadyToBuyJust:
    'Еще не готовы купить? Сохраните товар на потом с помощью расширения для браузера Karma и делайте покупки более осознанно. Вы можете следить за всеми сохраненными товарами в одном месте. ',
  automaticallyFindsCouponCodes: 'Автоматически находит коды купонов',
  findsAndAppliesCodes:
    'Karma автоматически находит и применяет лучший купон вместо вас, поэтому вы всегда будете знать, что делаете самую выгодную покупку.',
  soYouCanBuyAtTheRightTime: 'Вы сможете делать покупки в нужный момент',
  usesCleverTechnologies:
    'Karma использует интеллектуальные технологии, чтобы отслеживать снижение цен и повторное появление товаров на складе, чтобы вы могли сделать покупку в нужное время. ',
  notOnlySave:
    'Karma не только экономит ваши деньги, но и позволяет вам их зарабатывать! Никаких баллов. Никаких уловок. Вы зарабатываете реальные деньги всякий раз, когда делаете покупки.',
  makeImpact: 'Приносите пользу!',
  donate:
    'Делайте покупки, как обычно, и смотрите, как Karma делает пожертвования. При каждой покупке на сумму более {{over, number}} $ мы жертвуем {{dollars, number}} $ на выбранное вами доброе дело.',
  accessToOffers: 'Доступ к эксклюзивным предложениям',
  accessItems:
    'Получайте доступ к своим сохраненным товаром в одном месте, находите эксклюзивные предложения и узнавайте, что происходит в мире, на Karma.',
  hereIsHowItWorks: 'Вот как это работает',
  learnMoreAboutGives: 'Подробнее о Karma Gives',
  alwaysKnowWhenPricesDrop: 'Всегда знайте, когда падают цены',
  getNotifiedWhenBackInStock: 'Получайте уведомление, когда товар вновь появляется в продаже',
  findsYouBestCoupons: 'Находит вам лучшие купоны',
  getKarmaCashWhenYouShop: 'Получайте Cash Back за покупки',
  easilySaveAllThings: 'Легко экономьте на всех ваших любимых товарах в более чем {{value, number}} тыс. магазинов',
  karmaProvidesGreatTechnology:
    'Karma предоставляет вам отличные технологии и гибкость, чтобы делать покупки умнее, и помогает вам избежать ненужных импульсивных покупок. Все это позволяет сэкономить время и деньги.',

  accountActivityAndImportantInformation: 'Активность в аккаунте и важная информация',
  addKarmaToYourDesktop: 'Добавьте Karma на свой рабочий стол, чтобы делать покупки<br/>в рабочее время.',
  addNumberItemsToList: 'Добавить {{value}} товара(-ов) в список',
  addOneItemToList: 'Добавить 1 товар в список',
  addStuffYouFindToThisListToKeepItOrganized:
    'Добавьте найденные товары в этот список, чтобы он остался упорядоченным.',
  alrightBut: 'Хорошо, но так вы будете очень боятся пропустить что-то важное!',
  areYouSureYouWantToDisconnectFromPaypal: 'Уверены, что хотите отключиться от Paypal?',
  balance: 'Баланс',
  buyWhateverYouWant: 'Покупайте, что хочешь, и не расстраивайте своего сотрудника в банке.',
  cashIsBack: '<1>Деньги</1> возвращаются',
  cashIsBackColoredRight: 'Деньги <1>возвращаются</1>',
  checkItOffAsYouBuy: 'Отмечайте галочкой после покупки',
  connectToPayPalToCashOut: 'Подключите счет PayPal для вывода своих вознаграждений',
  downloadOurApp: 'Загрузите наше приложение и возьмите с собой <1>Karma</1>',
  dropSomeShoppingInspo: 'Вдохновитесь свою семью на покупки.',
  earnKarmaCashShort: 'До {{percent, number}}% Cash Back',
  earned: 'Заработано',
  enterYourPassword: 'Введите пароль',
  firstAddToList: 'Во-первых, добавьте в список',
  followOnLinkedin: 'Подпишитесь на нас в LinkedIn',
  freshOutCoupons: 'Свежие купоны',
  getBuzzedWhenYourWishes:
    'Получайте звуковое оповещение 🐝, когда ваши «желания» падают в цене или снова появляются в продаже.',
  getIt: 'Получите их',
  getTheApp: 'Получите приложение',
  gotIt: 'Понятно',
  gotStuck: 'Застряли? Нажмите <1>здесь</1>, чтобы двигаться дальше.',
  happyShoppers: '👉 Более {{count, number}} млн счастливых покупателей',
  howElseCanWeImproveKarma: 'Как еще мы можем улучшить Karma?',
  iNeedThisInMyLife: 'Мне это нужно в моей жизни',
  info: 'Информация',
  itemUpdatesUnsubscribe: 'Актуальная информация о товарах (падение цен, пополнение запасов и т.д.)',
  itsAGhostTown: 'Это город-призрак',
  joinTheTeam: 'Присоединяйтесь к команде',
  karmaGetsYouTheLowestPossiblePrice: 'Karma каждый раз дает вам самую низкую 👏возможную👏 цену.',
  karmaIsAnApp:
    'Karma — это приложение и расширение, которое поможет вам сэкономить время и деньги во время покупок в Интернете.',
  karmaYourFavoriteBrands: '<1>Karma</1> ваши любимые бренды',
  karmaYourFavoriteBrandsMobile: '<1>Karma</1> ваши любимые бренды',
  knowHowToShopBetter: 'Узнайте, как <1>делать покупки лучше</1>, чем все остальные',
  letsPlay: 'Давайте поиграем',
  lolWereAVerbNow: '(Лол, мы теперь глагол)',
  lookAtYouLittleScroller: 'Взгляните на себя, любитель скроллинга. Респект вам за то, что зашли так далеко.',
  lookAtYouLittleScrollerMobile: 'Взгляните на себя, любитель скроллинга.',
  lookingForInfluencer: 'Ищете возможности для рекламного партнерства?',
  markItemsYouveMadeYourOwnItFulfillsSoGood: 'Отметьте товары, которые вы приобрели. Он так хорошо справляется!',
  markNumberItemsAsFullfilled: 'Вы собираетесь пометить {{value}} позиции(-ий) как выполненные',
  meetYouAtIn: 'Встретимся в {{retailer}} через 3 секунды...',
  missOut: 'не упускайте',
  missingYouAlready: 'Уже скучаю по вам!',
  money: 'денег',
  never: 'Никогда',
  nevermind: 'Не обращайте внимания',
  noFomoHere:
    'Никакого страха упустить, что-то важное. Мы сигнализируем вам, когда ваши «пожелания» упадут в цене или снова появятся на складе.',
  noNotificationsYet: 'У вас актуальные данные',
  noNotificationsYet2: 'Как только цены упадут или появятся новые, вы найдете их здесь.',
  nowLetsTalPrivacy: 'Теперь давайте поговорим о <1>конфиденциальности<1/>',
  nowLetsTalkAboutPrivacy: 'Теперь давайте поговорим о конфиденциальности 🤫',
  onlineShoppingButBetter: 'Онлайн-покупки, но <1>лучше</1>',
  orCopyTheLinkBelowAndSend: 'Или скопируйте ссылку ниже и отправьте ее членам семьи в старом стиле.',
  other: 'Другое',
  passwordValidationNote:
    'Должен содержать не менее 8 символов и включать минимум одну заглавную букву, строчную букву и цифру.',
  payLess: 'Платите меньше',
  playFavesWithYourItems: 'Добавляйте свои товары в избранное',
  preparingYourKarmaCash: 'Готовим Karma к оплате.',
  savingMoneyIsHotLetsGetOnThat: 'Экономить деньги — это здорово. Давайте займёмся этим ✌️',
  search: 'Поиск',
  seeHowToSave: 'Узнайте, как сэкономить',
  skipForNow: 'Пропустить сейчас',
  soFarWeSavedYou: 'До данного момента мы сэкономили вам',
  sorryForInconvenience: 'Извините за неудобства — обещаем, что оно того стоит.',
  starReviews: '👉 Более {{count, number}} тыс. отзывов со средней оценкой 4,7',
  starTheThingsYouNeedInYourLifeForQuickAccess:
    'Отмечайте звездочкой все, что вам нужно в жизни, для быстрого доступа.',
  stillWannaUnsubscribe: 'Все еще хотите <1>отписаться от всех эл. писем Karma</1>?',
  storePromotionsAndOtherMarketingEmails: 'Промоакции магазинов и другие маркетинговые эл. письма',
  storesWorldwide: '👉 Более {{count, number}} тыс. магазинов по всему миру',
  stuffWorthSavingGoesHere: 'Товары, которые стоит сохранить, отправляются сюда 👇',
  sureYouWantToDeleteTheseNumberItems: 'Уверены, что хотите удалить эти {{value}} товара(-ов)?',
  sureYouWantToDeleteThisList: 'Уверены, что хотите удалить этот список?',
  takeControlOfYourInbox: 'Возьмите под контроль свой почтовый ящик',
  theMotherOfAllWishLists: 'Лучший из всех <1>списков желаний<1/>',
  thisFieldIsRequired: 'Это поле обязательно для заполнения',
  tryAgain: 'Попробуйте еще раз',
  trySearchingForSomethingElse: 'Попробуйте поискать что-то другое.',
  updatePreferences: 'Обновить настройки',
  wantIt: 'Хочу это',
  weAreBusySelfImproving: 'Мы заняты самосовершенствованием',
  weAreVerySeriousAboutPrivacy:
    'Мы очень серьезно относимся к конфиденциальности и никогда не будем продавать ваши данные третьим лицам. Никогда.',
  weDontSellYourData: 'Мы не продаем ваши данные',
  weGotStuckOnOurWay: 'Мы застряли на пути к {{retailer}}!',
  weHitYouUp: 'Мы свяжемся с вами, когда найдем промокод для этого магазина.',
  weHustleForCoupons: 'Мы охотимся за купонами',
  weUseBankLevelSecurity: 'Мы используем меры безопасности банковского уровня',
  wellApplyCodesThatSaveYouMoney: 'Мы применим коды, которые помогут вам сэкономить $$$.',
  wellTrackAndScanForCoupons:
    'Мы будем отслеживать и сканировать купоны, чтобы вам не пришлось делать это.  <br/> (Хорошо, мы не будем, но наш ИИ будет)',
  wellTrackAndScanForCouponsMobile: 'Мы будем отслеживать и сканировать купоны, чтобы вам не пришлось делать это.',
  wereAVerbNowLol: '(теперь мы глагол ЛОЛ)',
  wereGoingShopping: 'Мы идем за покупками',
  wereHereToMakeItYours: 'Мы здесь, чтобы <1>#сделать_его_вашим </1>',
  whyUnsubscribeFromAllOurMoneySavingEmails:
    'Зачем отписываться от всех писем с экономией денег, если можно отключить только те, которые неактуальны?',
  withKarmaYouCanBuy:
    'С помощью Karma вы можете купить <br />все, что захотите, и не расстроить <br /> вашего менеджера в банке.',
  withKarmaYourCash:
    'Благодаря Karma ваши деньги возвращаются к вам. Это волшебные деньги, как будто заколдованные магией вуду.',
  yesDisconnect: 'Да, отключиться',
  yesIDoThat: 'Да, я так делаю',
  youHaveToReconnectToWithdraw: 'Чтобы вывести Cash Back, вам нужно будет подключиться заново.',
  youNeedToSaveItemsBeforeYouCanShareYourList: 'Вам нужно сохранить товары, прежде чем вы сможете поделиться списком.',
  youReATen:
    'У вас 10, и вы платите с помощью Karma? Покупайте онлайн и получайте 👏каждый👏 раз получайте самую низкую возможную цену.',
  youReAboutToMuteNumberItems: 'Вы собираетесь отключить уведомления для {{value}} товаров',
  yourCashWillComeBackToYou: 'Ваши деньги вернутся к вам. Это волшебные деньги, как будто заколдованные магией вуду. ',
  yourInformationIsSecured: 'Ваша информация полностью защищена с помощью новейшего 256-битного шифрования.',
  yourSearchCameUpEmpty: 'Ваш поиск не принес результатов',
  total: 'Итого',
  keepAnEyeOutForTheStatusUpdatesWeWillSendToEmail:
    'Следите за обновлениями статуса, которые мы отправим на {{email}}.',
  psaDidYouKnow: 'PSA: Знаете ли вы, что вы можете',
  addWishItemsFromAnyBrand:
    'Добавьте «желаемые» товары любого бренда и ждите, пока мы не скажем, что пришло время купить их.',
  capturePurchaseReadyShoppers:
    'Привлеките покупателей, готовых к покупке, продемонстрировав свои самые популярные купоны.',
  gainFullFunnelInsights:
    'Получайте во всех каналах представление о намерениях покупателя при каждом сохранении товара',
  boostCartEngagement:
    'Повысьте привлекательность корзины с помощью наших новостей о товарах в режиме реального времени.',
  promoteLongTermGrowth:
    'Содействуйте долгосрочному росту с помощью адаптированных кампаний в рамках экосистемы Karma.',
  reachNewAudiences: 'Охватите новые аудитории с помощью различных кампаний, адаптированных к вашему бренду',
  influencerCollaborations: 'Сотрудничество с инфлюэнсерами',
  teamUpWithTopInfluences:
    'Объединитесь с лучшими инфлюэнсерами, которые лучше всего подходят к идентичности вашего бренда.',
  socialPosts: 'Посты в соцсетях',
  giveANewFollowing: 'Привлеките подписчиков в ходе заказных, богатых контентом кампаний.',
  brandFocusedNewsletters: 'Информационные бюллетени, ориентированные на бренд',
  letYourOffersShine: 'Пусть ваши предложения выделяются в долгожданных курируемых эл. письмах.',
  driveTrafficWhenYouNeedIt:
    'Привлекайте трафик туда, где вам нужно, с помощью размещения товаров на нашей главной странице, доступных для покупок',
  dashboardBanners: 'Баннеры инфопанели',
  flauntYourLatestOfferings:
    'Продемонстрируйте свои последние предложения с помощью привлекающих внимание визуальных эффектов.',
  dailyFeatured: 'Ежедневные рекомендуемые',
  highlightDeals: 'Выделите предложения там, где это имеет наибольшее значение.',
  dedicatedPopUps: 'Целевые всплывающие окна',
  activelyServeYourPromos: 'Активно подавайте промоакции, чтобы их нельзя было пропустить.',
  createAnotherTouchpointForYourBrand: 'Создайте еще одну точку соприкосновения для своего бренда',
  increaseEngagement:
    'Повышайте уровень вовлеченности и конверсии с помощью целевых push-уведомлений на мобильных устройствах и в Интернете.',
  karmaIsOnlineShoppingButBetter: 'Karma — это онлайн-шопинг, но лучше.',
  transactionsNumber: '👉 Более {{count, number}} млн выгодных предложений',
  partnershipsReview4: 'Это потрясающее средство создания списков желаний и экономии денег!',
  partnershipsReviewAuthor4: 'Эмили Смит',
  partnershipsReview5:
    'Это буквально лучшее расширение, которое я когда-либо скачивала. Это лучший способ сэкономить деньги и одновременно получить их!',
  partnershipsReviewAuthor5: 'Селена Роблокс',
  noNeedToSlideIntoOurDMs:
    'Нет необходимости искать нас в мессенджерах (хотя вы могли бы😏). Наша команда готова помочь во всем, что вам нужно.',
  supportIssues: 'Вопросы поддержки',
  adsAndPartnerships: 'Реклама и партнерство',
  jobOpportunities: 'Возможности трудоустройства',
  publicRelations: 'Связи с общественностью',
  letsChat: 'Давайте пообщаемся в чате',
  earnings: 'Доходы',
  allTime: 'За все время',
  ordersMayTakeHoursToAppear: 'Появление заказов может занять до {{value, number}} часов.',
  youHaventReceivedAnyPayoutsYet: 'Вы еще не получили ни одной выплаты ',
  alerts: 'Оповещения',
  featuresReview1:
    'Я добавила кроссовки в свой список желаний и буквально на следующий день получила оповещение о скидке 50%. Как я вообще покупала что-либо до того, как нашла вас, ребята?',
  featuresReviewAuthor1: 'Сандра К. Мартинес, автор отзыва на App Store',
  featuresReview2:
    'Это действительно лучшее приложение для умных покупок, а я знаю и несколько других. Мне кажется, что я немного обманываю систему, потому что экономлю настоящие деньги! Раньше я всегда платил полностью и чувствовал себя полным лохом',
  featuresReviewAuthor2: 'Герти Д. Акерман, автор отзыва на App Store',
  featuresReview3:
    'Я покупала новый ноутбук со скидкой 25%. Когда я нажала «Оплатить с Karma», я заметил, что общая сумма к оплате стала еще меньше. Это происходит каждый раз, когда я плачу с помощью приложения',
  featuresReviewAuthor3: 'Ирэн Дж. Кокс, автор отзыва на App Store',
  downloadNow: 'Скачать сейчас',
  wannaBeDeskBuddies: 'Хотите вкусить плоды нашего успеха?',
  seeOpenPositions: 'Посмотрите вакансии',
  weLiveAndSwearBy: 'Мы живем и безгранично верим в...',
  goodKarma: 'Хорошую Karma (карму)',
  weBelieveThatGoodVibes: 'Мы верим, что ~хорошие вибрации~ — это образ жизни, и мы придерживаемся его.',
  beingTrue: 'Справедливость',
  theresNoUSvsU: 'Нет НАС против ВАС. Наши столы всегда круглые, и мы оставляем вам место за ними.',
  passion: 'Страстное увлечение',
  weHaveThatFireYouKnow: 'У нас пожар, понимаете? Мы работаем с драйвом, настойчивостью и любовью к тому, что делаем.',
  entrepreneurship: 'Предпринимательство',
  weWantItWeGetIt:
    'Если мы чего-то хотим, мы этого добиваемся. У нас нет времени на бесконечные встречи в Zoom. Мы стремимся к тому, чего хотим.',
  mutuality: 'Взаимность',
  wereMadeUpOfAwesomePeople:
    'Наш коллектив состоит из потрясающих людей, которые понимают, что командной работы недостаточно. Мы действительно дорожим друг другом.',
  buildCustomerLoyalty: 'Повышайте лояльность клиентов с помощью мгновенного кешбэка',
  itemSaving: 'Сохранение товара',
  itemUpdates: 'Новости о товаре',
  backInStockAlerts: 'Снова в наличии',
  lowInStockAlerts: 'Запасы на исходе',
  storePromotions: 'Акции в магазине',
  exclusive: 'эксклюзив',
  couponCopied: 'Купон скопирован',
  completedDesc:
    'Магазин подтвердил ваш заказ. Любые заработанные Cash Back могут быть выведены в течение {{days, number}} дней с даты покупки и только после того, как вы достигнете минимума в {{amount, number}} {{currency}}.',
  pendingDesc:
    'Магазин получил ваш заказ. Он может отображаться как ожидающий до {{days, number}} дней, в зависимости от политики возврата магазина.',
  cancelledDesc: 'Магазин сообщил нам, что ваш заказ был либо отменен, либо возвращен в полном объеме.',
  downloadNowItsFree: 'Скачайте сейчас, это бесплатно',
  weLiveToMakeOurShoppersHappy: 'Мы живем ради того, чтобы сделать наших покупателей счастливыми',
  moneySavedForYou: 'Деньги, сэкономленные для вас',
  happyShoppers2: 'Счастливые покупатели',
  starReviews2: '{{value, number}}-звездочные отзывы',
  storesWorldwide2: 'Магазины по всему миру',
  whyYouWill: 'Почему вы',
  it: 'it',
  multiBrandWishLists:
    'Мультибрендовые списки желаний? Реально круто. Находите то, что вам нравится, среди товаров любого бренда, добавляйте это в свой список Karma и ждите, пока мы не скажем, что пора купить товар.',
  addKarmaToYourMobile: 'Загрузите<br />наше приложение<br />и возьмите<br />Karma с собой в путь',
  appStoreReview1:
    'Я добавила палитру теней для век в свой список и на следующий день получила уведомление, что она предлагается со скидкой 50%. Спасибо!!',
  appStoreReview2: 'Тот факт, что самая низкая цена всегда у меня в кармане, очень опасен. Но он мне также нравится',
  appStoreReview3:
    'Только что получил самую низкую цену на новые наушники, пока ждал автобуса. Это просто слишком просто',
  appStoreReviewBy: 'Отзыв в App Store от: {{name}}',
  yourInfoSafeWithUs: 'Ваша информация в безопасности у нас',
  whyGiveOutYourCCDeets: 'Зачем раздавать документы направо и налево, если можно хранить их в одном месте?',
  partyForOne: 'Вечеринка для одного',
  wellNeverSellYourDataToAnyThirdParties:
    'Мы никогда не будем продавать ваши данные третьим лицам, и точка. Благодаря банковской безопасности ваши данные защищены от посторонних глаз.',
  buyWithoutATrace: 'Покупайте без следов',
  weWontLetAnyoneTrackYourShoppingHabits: 'Мы не позволим никому отслеживать ваши привычки. Мы вовсе вас не осуждаем.',
  spotSomethingYouLoveFromAnyBrand:
    'Находите то, что вам нравится, среди товаров любого бренда, добавляйте это в свой список Karma и ждите, пока мы не скажем, что пора купить товар.',
  needIt: 'Нужно это',
  appStoreReviewer: 'Автор отзыва на App Store',
  appStoreReview4:
    'Я так полагаюсь на это приложение, которое отслеживает все мои «желаемые» товары в одном месте, чтобы я смог купить их по наилучшей цене.',
  appStoreReview5: 'Это приложение помогло мне сэкономить кучу денег.',
  wishlist: 'Список желаний',
  getTheLowestPriceAtAllYourFavoriteBrands: 'Получите самые низкие цены на все ваши любимые бренды.',
  getTheAppForFree: 'Получите приложение бесплатно',
  addKarmaSpaced: 'Добавьте Karma<br />на свой ПК,<br />чтобы делать покупки<br />в рабочее время.',
  spotSomethingYouLoveFromAnywhere:
    'Находите то, что вам нравится, откуда угодно, добавляйте это в свой список Karma и тусуйтесь, пока мы не скажем, что пора покупать.',
  getCouponsCashbackWithPeriod:
    'Получайте купоны, кешбэк и оповещения о снижении цен.<br />Всегда платите самую низкую цену.',
  getCouponsCashbackWithAnd:
    'Получайте купоны, кешбэк, оповещения о снижении цен<br />и всегда платите самую низкую цену.',
  clickTheLoginLinkFromYourPhone: 'Нажмите на ссылку входа с телефона, чтобы получить доступ к приложению Karma.',
  getItOn: 'Получите его на',
  downloadOnThe: 'Скачайте на',
  likeShoppingFromYourComputer: 'Нравится делать покупки с компьютера?',
  getTheKarmaExtensionToShopEvenBetter: 'Получите расширение Karma, чтобы делать покупки еще лучше.',
  headerMobileLogin: 'Karma | Установить',
  noFomoHereMobile:
    'Никакого страха упустить, что-то важное. Мы сигнализируем вам, когда ваши «желания» упадут в цене или снова появятся на складе.',
  withKarmaYourCashMobile:
    'Благодаря Karma ваши деньги возвращаются к вам. Это волшебные деньги, как будто заколдованные магией вуду.',
  spotSomethigYouLoveMobile:
    'Находите то, что вам нравится, откуда угодно, добавляйте это в свой список Karma и тусуйтесь, пока мы не скажем, что пора покупать.',
  wellTrackAndScanForCouponsMobile2:
    'Мы будем отслеживать и сканировать купоны, чтобы вам не пришлось делать это. (Хорошо, мы не будем, но наш ИИ будет)',
  weHustle: 'Мы активно ищем',
  forCoupons: '<1>купоны</1>',
  theMotherOfAll: 'Лучший из всех',
  wishlists2: 'списков желаний',

  // NEW PHRASES
  moneySavedForUsers: 'Money saved for users',
  whyYouLoveMerchantsTitleDesktop3: '<1>One-swipe<1/> checkout is yours',
  whatItsLikeWorkingAtKarma2: 'What’s it like working at Karma?',
  makeItYours: 'Make it yours',
  continueWith: 'Continue with {{provider}}',
  onItsWay: 'On its way...',
  weVeEmailedInstructionsForResettingYourPassword:
    'We’ve emailed instructions for resetting your password to {{email}}',
  wrongEmailTryAgain: 'Wrong email? Try again',
  goToEmail: 'Go to email',
  heyYouLetsJumpBackIntoSaving: 'Hey you! Let’s jump back into saving',
  firstConfirmItsYou: 'First, confirm it’s you',
  letsDoThis: 'Let’s do this',
  signUpAndGet: 'Sign up and get',
  moneyOnUs: '{{currency}}{{value, number}} on us',
  usersHeroTitle: 'Your\nbank account’s gonna love this.',
  tellMeMore: 'Tell me more',
  createNewPassword: 'Create new password',
  joinKarma: 'Join Karma',
  whyYouLoveMerchantsSubtitle3: 'Pay with Karma works with all retail platforms, with zero\nintegration and no fees.',
  saveItemsFromStores: 'Save items from your favorite stores with a single click',
  easilySaveAndKeep:
    'Easily save and keep track of everything you want to buy. The best\npart? You’ll get notified the second any of your saved items\ngo on sale, or come back in stock.',
  addTheFreeKarma:
    "Add the free Karma button to your browser so you can\neasily keep track of everything you want to buy. The best\npart? You'll get notified the second any of your saved items\ngo on sale, drop in price, or come back in stock.",
  getButtonAndGetEverything: 'Get the free Karma button and\nget everything you want on sale',
  getKarmaItIsFree: "Get Karma - It's Free!",
  onYourPhone: 'On your phone? Save items on the go with our free app',
  hereHowTheButtonWorks: "Here's how the Karma\nbutton works",
  dontSellMyPersonalInformation: 'Don’t sell my personal information',
  postCode: 'Postcode',
  ifThisWontHelp: "If this won't help, ",
  contactOurSupportCenter: 'contact our support center.',
  wellKeepAnEyeOnIt: 'We’ll keep an eye on it & will let u know ASAP if the price drops',
  seeYourSavedItems: 'See your saved items',
  logInAndSaveItemToKarma: 'Login & Save item to Karma',
  blogPromotions: 'Blog promotions',
  goToStore: 'Go to store',
  visitStorePage: 'Visit store page',
  favStoresUpdated: 'Your favorite stores were successfully updated.',
  availableCoupons_plural: '{{count}} available coupons',
  availableCoupons: '{{count}} available coupon',
  findAndComparedTheBestDeals: 'Finds and compares the best deals',
  karmaHelpsYouShopSmarter: 'Karma helps you shop smarter by finding the best benefits and rewards at checkout',
  expiring: 'Expiring',
  today: 'Today',
  tomorrow: 'Tomorrow',
  days: '{{count, number}} DAY',
  weeks: '{{count, number}} WEEK',
  months: '{{count, number}} MONTH',
  daysPlural: '{{count, number}} DAYS',
  weeksPlural: '{{count, number}} WEEKS',
  monthsPlural: '{{count, number}} MONTHS',
  tellUsWhyYouUninstalledTheExtension: 'Tell us why you uninstalled the extension',
  tooManyPopUpsWhileIShop: 'Too many pop-ups while I shop',
  couponsDontWork: 'Coupons don’t work',
  dataPrivacyConcerns: 'Privacy concerns',
  dataPrivacyConcernsTitle: 'Your privacy matters',
  dataPrivacyConcernsDescripReason:
    'Online privacy is serious business.<2/>We’re <1>GDPR & CCPA compliant</1>, and you can read </2>our <1>Privacy Policy</1> if you want all the details!',
  noRelevantDealsInMyFavedStores: 'No relevant deals in my faved stores',
  noRelevantDealsInMyFavedStoresDescription:
    'Karma <1>tracks price drops</1><2/> and <1>restocks</1>, so when a deal pops up, <1>you’ll<2/> know first.</1><2/> Stick around, and we’ll keep an eye out for<2/> savings!',
  theKbuttonWasInMyWay: 'The ‘K button’ was in my way',
  theKbuttonWasInMyWayDescription: 'No need to kick us out completely.<2/> Want to try adjusting it? Check out how',
  tooManyPopUps: 'Too many pop ups',
  tooManyPopUpsTitle: 'Timing is everything.',
  tooManyPopUpsDescription:
    'You can actually tweak how often Karma helps in<2/> settings, so it only <1>appears when you want it to.</1><2/> Give that a try?',
  causedProblemsWithMyBrowser: 'Caused problems with my browser',
  tellUsMoreOptional: 'Tell us more (optional):',
  shareYourThoughtsWithUs: 'Share your thoughts with us',
  myFavoriteStoresAreNotSupported: 'My favorite stores are not supported',
  notReadyToLetGoYet: 'Not ready to let go yet? Reinstall Karma with just one click',
  chatWithUsAndGet: 'Chat with us & get<br />${{count}} Amazon Gift Card',
  scheduleAMeetingAndEarnGiftCard:
    'Schedule a {{minutes}}-minute interview and earn a<br />${{count}} Amazon gift card.',
  scheduleAnInterview: 'Schedule an interview',
  compareProductsBeforeYouBuy: 'Compare products before you buy',
  downloadWithKarmaAndSaveMajorCash: 'Download Karma<br/>and save major $$$',
  youSearchedFor: 'You searched for',
  yourSavedItems: 'Your saved items',
  moreForYou: 'More for you',
  headerGlobalSearch: 'Karma | {{query}}',
  noResultsFoundFor: 'No results found for',
  pleaseReviewYourSpellingOrTryDifferentKeyword: 'Please review your spelling or try different keyword',
  heyThere: 'Hey, {{name}}',
  myAccount: 'My account',
  accountSettings: 'Account settings',
  trendingNow: 'Trending now',
  helpUsImproveKarma: 'Help us improve Karma',
  yourFavoriteStores: 'Your favorite stores',
  chooseYourFavoriteStores: 'Choose your favorite stores',
  viewStoreInfo: 'View store info',
  addStore: 'Add store',
  findMoreStores: 'Find more stores',
  whatAreYouShoppingFor: 'What are you shopping for?',
  searchForAnyItemBrandOrStore: 'Search for any item, brand or store',
  savedFromStore: 'Saved from store',
  manageFavoriteStores: 'Manage favorite stores',
  hasNoActiveCoupons: '{{retailer}} has no active coupons',
  checkOutOtherStores: 'Check out other stores for more deals',
  youCanStillEarn: 'You can still earn {{number}}% cashback with Karma!',
  retailerCoupons: '{{retailer}} coupons',
  nothingSavedYet: 'Nothing saved yet?',
  useOurBrowserExtension:
    'Use our browser extension on your {{retailerName}} visit to quickly add items to your favorites. Your shopping journey starts here!',
  letsMakeItPersonal: 'Let’s make it personal',
  selectAndTrack: 'Select your favorite stores and track coupons and deals',
  chooseYourFaves: 'Choose your faves',
  code: 'Code',
  itemFound: '{{count, number}} item found',
  itemFound_plural: '{{count, number}} items found',
  storeFound: '{{count, number}} store found',
  storeFound_plural: '{{count, number}} stores found',
  itemsTitle: 'Items',
  storeInfo: 'Store info',
  preOwned: 'Pre-owned',
  refurbished: 'Refurbished',
  favorited: 'Favorited',
  allPromotionsOrOffers:
    "All promotions or offers by any of our partners are subject to the applicable partner's terms and conditions, which may be changed by the partner at its discretion. We may receive a commission for purchases made through our links or using our coupons. Eligibility for a welcome bonus is subject to section 5 of Karma’s Terms & Conditions.",
  shippingInfo: 'Shipping info.',
  freeShipping: 'Free shipping',
  overMinAmount: 'over {{currency}}{{value, number(minimumFractionDigits: 2)}}',
  delivers: 'Delivers',
  deliveryDays: '{{value, number}} days',
  freeReturns: 'Free returns',
  upToDays: 'up to {{value, number}} days',
  deliveryInfo: 'Delivery info.',
  returnsInfo: 'Returns info.',
  notAvailable: 'Not available',
  minOrderMayApply: 'Min. order may apply',
  hottestDeals: 'Hottest deals',
  discoverCouponsAndExclusiveOffers: 'Discover coupons and exclusive offers',
  moreFromStore: 'More from {{store}}',
  seeWhatsTrendingNow: 'See what’s trending now',
  automaticallyApplyCoupons:
    'Automatically apply coupons at checkout, save what you love and earn cashback — all with the Karma extension.',
  deleteMyAccount: 'Delete my account',
  areYouSureDeleteAccount: 'Are you sure you want to delete your account?',
  deletingYourAccountWill:
    'Deleting your account will permanently remove all of your information, your saved items and your earnings from our database, and this action cannot be undone.',
  cancel: 'Cancel',
  accountDeletedSuccessfully: 'Account deleted successfully',
  shopOnTheGo: 'Shop on-the-go with Karma app',
  moveFromDevice: 'With Karma, effortlessly move from one device to another as you shop.',
  fewMomentsWeAreStillWorkingOnSavingItemsToThisList:
    'Few moments, we’re still working on saving items to this list... ',
  notificationDate: '{{date, shortFromNowDate}} ago',
  enableKarmaOn: 'Enable Karma on Safari',
  karmaNeedsToBeActivated: 'Oops! Karma needs to be activated',
  toAccessOurCouponScanner: 'to access our coupon scanner',
  dontSeeReview: 'I don’t see a “Review” button',
  iosOnboardingFlowYouNeedToUseSafari: 'You need to be in Safari to use<1></1>the Karma extension',
  iosOnboardingFlowCopyTheLink: 'Copy the link below and paste it in<1></1>Safari to continue.',
  iosOnboardingCopyLink: 'Copy link',
  iosOnboardingLinkCopied: 'Link copied',
  tapExtensionThenSelect: 'extension, then <1>select both middle options</1>',
  tap: 'Tap',
  activate: 'Activate',
  grantAccess: 'Grant access',
  continueShopping: 'Continue shopping',
  sweOnboardingStep1_1_2: 'in your search bar',
  sweOnboardingStep1_2: 'Select <1>“Manage Extensions”<1/>',
  sweOnboardingStep1_3: 'Toggle on <1>“Karma”</1>',
  sweOnboardingStep2_1_old: 'Tap the <1>A</1><2>A</2> in the address bar again',
  sweOnboardingStep2_2_old:
    'Tap the Karma extension <1></1>, and select <3>“Always Allow...”</3>, then <5>“Always Allow on Every Website”</5>',
  sweOnboardingStep2_3_old: 'Select “Always allow”',
  sweOnboardingStep2_4_old_1: 'Select “Always allow”',
  sweOnboardingStep2_4_old_2: '“On every Site”',

  sweOnboardingStep2_5_old_1: 'Go back to the',
  sweOnboardingStep2_5_old_2: 'Karma app',
  sweOnboardingStep2_1: 'Tap <1>“Review”</1> in the top right corner, then <3>select both middle options</3>',
  shopSmarter: 'Shop better with\nthe power of AI',
  joinOurUsers: 'Join our {{number, number}} million users\nwho are shopping\nbetter from all their\ndevices',
  browseAndBuy:
    'Browse and buy from our desktop extension or\nuse the Karma app to ensure you’re always\ngetting the most out of your purchase.',
  joinCard1: '<0>$5 cash</0><1>at sign-up</1>',
  joinCard2: '<0>15K</0><1>5 star reviews</1>',
  joinCard3: '<0>13M+</0><1>coupons applied</1>',
  joinCard4: '<0>80 million</0><1>items saved</1>',
  joinCard5: '<0>$482</0><1>yearly avg savings</1>',
  joinCard6: '<0>$126</0><1>avg Cash Back earnings</1>',
  joinCard7: '<0>{{value}}M+</0><1>shoppers</1>',
  joinCard8: '<0>$7.50</0><1>avg order savings</1>',
  whatMakesKarmaGood: 'What makes Karma\nso good?',
  karmaGoodTitle1: 'Karma let’s you shop\nbetter from anywhere',
  karmaGoodDescription1:
    'Karma’s browser extension meets you\nwherever you shop. Shop directly in the Karma\napp or share the items you want to Karma.',
  karmaGoodTitle2: 'Helps you plan your\nnext purchases',
  karmaGoodDescription2:
    'Not ready to buy just yet? Save it for later in the\nKarma app or share it to Karma and shop more\nmindfully. You can keep an eye on all your\nsaved items in one place.',
  karmaGoodTitle4: 'So you can buy at the\nright time',
  karmaGoodDescription4:
    "Karma uses clever technology to track if the\nprice drops, or when it's back in stock, so you\ncan buy at the right time.",
  karmaGoodTitle5: 'Automatically finds you\n coupons at checkout',
  karmaGoodDescription5:
    'Karma automatically finds and applies the best\n coupons for you while you shop on Safari, so\n you know you get the best price every time.',
  onlyOnMobile: 'Only on the mobile app',
  empowerTouToMake: 'Empower you to\nmake the right\nchoices at the right\ntime when you shop\nonline.',
  dontTakeOurWord: 'Don’t take our word for it',
  totalSavings: 'Total savings',
  joinOurUsersDesktop: 'Join our {{number, number}} million users who are\nshopping better from all their devices',
  andAutomaticallyFindsYouCouponsAtCheckout: 'And automatically finds you coupons at checkout',
  clickAlwaysAllowOnEveryWebsite: 'Click <2>“Always Allow on Every Website“</2> so we can work on all your fave sites',
  weNeedYourPermissionToAutomaticallyShowYouTheBestDeals:
    'We need your permission to automatically show you the best deals on all your favorite shopping websites.',
  yourPrivacyAndSecurityIsImportantToUs: 'Your privacy and security are important to us - it’s in our',
  whileKarmaWillStillWork: 'While Karma will still work, it’ll require more effort on your part to find deals.',
  unfortunatelyWithoutTheAlwaysAllowPermission:
    'Unfortunately, without the “Always Allow on Every Website” permission you’ll have to manually click Karma whenever you shop',
  noThanksSignUpForAnAccount: 'No thanks, Sign up for an account',
  logInWithEmail: 'Log in with email',
  signUpWithEmail: 'Sign up with email',
  iAgreeToTermsOfUseAndPrivacyPolicy: 'I agree to <1>Terms of Use</1> and <3>Privacy Policy</3>',
  joinOurEnergeticTeam: 'Join Our Energetic Team',
  atKarmaWeReNotJustAboutWork:
    'At Karma, we’re not just about work; we’re about creating an environment where everyone’s input is valued and where each day brings a new opportunity for growth and impact.',
  beAPartOfTheJourney: 'Be a part of the journey',
  noPositionsAvailable: 'No positions available',
  apply: 'Apply',
  dontSeeAnythingThatFitsYourSkillSet:
    "Don't see anything that fits your skill set? Don't let that stop you from reaching out! If you think you can help us grow, send an email to",
  ifYouReReadyToMakeAnImpact:
    'If you’re ready to make an impact and thrive in a setting that values speed, fun, and collaboration, Karma might be your next great adventure.',
  exploreOurCareerOpportunities:
    'Explore our career opportunities and find out how you can contribute to our exciting journey ahead. Join us, and let’s achieve greatness together!',
  welcomeToKarma:
    'Welcome to Karma—where technology meets savvy shopping. Join us in our mission to revolutionize the way you shop, ensuring every purchase is just right for you.',
  empoweringSmartShopping: 'Empowering Smart Shopping:\nThe Karma Story',
  ourMissionPart1:
    'At Karma, we believe in empowering shoppers to make wise and informed purchasing decisions. Founded in 2015, our mission has always been to guide consumers toward smarter, more responsible shopping. As both a browser extension and mobile app, Karma harnesses the power of advanced AI to enhance your shopping experience. This technology predicts the optimal time to make a purchase, ensuring you get the best deal possible.',
  ourMissionPart2:
    'Over the years, Karma has continuously evolved, integrating cutting-edge technology to keep pace with the dynamic e-commerce landscape. We take pride in helping our users avoid buyer’s remorse and overspending by providing them with the tools they need to shop confidently!',
  hearFromOurUsers: 'Hear from our users',
  karmaPatents: 'Karma patents',
  systemAndMethodForPreauthorizing: 'System and method for preauthorizing database transaction commits',
  systemAndMethodForScraping: 'System and method for near real time web scraping',
  startYourShoppingJourney: 'Start your shopping journey',
  searchForItemBrandStore: 'Search for an item, brand or store',
  quillDisclosure: 'HP, Epson, & Samsung excluded',
  theKButtonIsInMyWay: 'The K button is in my way',
  iOnlyInstalledItForAOneTimeDeal: 'I only installed it for a one-time deal',
  iOnlyInstalledItForAOneTimeDealTitle: 'We love a savvy shopper!',
  iOnlyInstalledItForAOneTimeDealDescription:
    'But did you know Karma helps you <1>save every<2/> time you shop?</1> No extra effort needed.<2/> Why not keep it around?',
  itWasntHelpful: 'It wasn’t helpful',
  itWasntHelpfulTitle: 'Karma’s got your back!',
  itWasntHelpfulDescription:
    'We track <1>price drops, restocks, and give<2/> you Cash Back.</1><2/> In the US? We’ll show you the <1>best credit card rewards at checkout.</1><2/> Give it another shot?',
  iUseOtherShoppingExtensions: 'I use other shopping extensions',
  iUseOtherShoppingExtensionsDescription:
    'But don’t forget, Karma finds <1>hidden price drops</1><2/> and <1>exclusive rewards</1> that others might miss.<2/> Why not double up?',
  tooManyCouponPopupsAtCheckout: 'Too many coupon pop-ups at checkout',
  cookies:
    'Karma uses cookies to ensure you see the things we think you’ll love the most. <2>Click here</2> to read our full policy',
  decline: 'Decline',
  confirmYourCookieSettings: 'Confirm your cookie settings',
  youControlHowWeUseCookies:
    'You get to control how we use cookies on each device and browser you use. These settings will apply to your current device when you use {{browser}}.',
  whatAreCookies: 'What are cookies?',
  cookiesAndTrackingTechnologies:
    'Cookies and tracking technologies are small text files stored on your device when you use a web browser. Some cookies are essential for you to use our site, while other cookies collect data about your browsing habits. We use this data to give you the best experience.',
  marketing: 'Marketing',
  weUseMarketingCookies: "We use marketing cookies to deliver ads we think you'll like.",
  marketingCookiesLet: 'For example, marketing cookies let us show you personalized ads based on your interests.',
  performance: 'Performance',
  weUsePerformanceCookies: 'We use performance cookies to understand how you interact with our site.',
  performanceCookiesHelp:
    'For example, performance cookies help us learn which parts are the most popular and which parts we could improve for you.',
  functional: 'Functional',
  weUseFunctionalCookies: 'We use functional cookies to customize your experience.',
  functionalCookiesLet:
    'For example, functional cookies let us remember your preferences like language, country or region, and text sizes.',
  essential: 'Essential',
  weUseEssentialCookies: 'We use essential cookies to make our site work for you.',
  essentialCookiesLet:
    'For example, essential cookies let you securely sign in and browse our site. These cookies help us keep your account safe and prevent fraud.',
  youCanReadMoreAboutCookies: 'You can read more about how we use cookies in our <2>Cookie Statement</2>.',
  confirmCookieSettings: 'Confirm Cookie Settings',
  noMinimumOrderValue: 'No minimum order value',
  fromToDays: '{{value, number}} to {{value2, number}} days',
  headerLogin: 'Karma | Login',
  headerOnboarding: 'Karma | Onboarding',
  yourDataHasBeenRemoved: 'Your data has been successfully removed.',
  confirmationCode: 'Confirmation code: {{code}}',
  startOnlineShopping: 'Start online shopping to see Karma in action',
  trendingOffers: 'Trending Offers',
  useCode: 'Use code: {{code}}',
  getDeal: 'Get Deal',
  buyNow: 'Buy now',
  trendingCoupons: 'Trending Coupons',
  searchResultsFor: 'Search Results for "{{search}}"',
  trendingItems: 'Trending Items',
  curateSmartWishlists: 'Curate Smart wishlists',
  karmaWillLetYouKnow: 'Karma will let you know when the items you want go on sale or are back in stock',
  saveEarnAtCheckout: 'Save & Earn at checkout',
  weApplyBestCoupon:
    'We’ll automatically apply the best coupon codes on the web at checkout & reward for your purchase on 1000’s of stores',
  scanToGetApp: 'Scan to get the app',
  unlockYourCreditCardsBenefits: 'Unlock your credit cards benefits',
  easilyCompareBetweenCreditCards:
    'Easily compare between the credit cards rewards to choose the best one to use at checkout',
  emailPositiveFeedbackThankYou: 'Thank you for your feedback!',
  emailPositiveFeedbackYourExperience: 'Share your experience by leaving a review on your platform of choice:',
  headerPositiveFeedback: 'Karma | Email Positive Feedback',
  headerNegativeFeedback: 'Karma | Email Negative Feedback',
  emailNegativeFeedbackTitle: 'We’re listening, share your feedback',
  emailNegativeFeedbackSubTitle:
    'To help us resolve the issue faster, please let us know what’s wrong with the notification',
  emailPriceDoesNotMatch: 'The email price does not match the website price',
  emailItemNotOnSale: 'The item is not on sale',
  emailItemOutOfStock: 'The item is out of stock',
  emailLinkNotWorking: 'The link is not working',
  emailPromoCodeNotAccepted: 'Promo code is not accepted by store',
  emailPromoCodeOnPage: 'Couldn’t apply the promo codes on the page',
  emailOther: 'Other',
  headerNegativeFeedbackSuccess: 'Karma | Negative Feedback Success',
  emailNegativeFeedbackSuccessTitle: 'Thank you for submitting your feedback!',
  emailNegativeFeedbackSuccessSubTitle: 'Our support team is on it, and we’ll be sure to update you soon.',
  enterValue: 'Enter value...',
  httpErrorOccurred: 'An error occurred, please try again later',
  everWonderWhichCreditCard: 'Ever wonder which credit card to use to get the best rewards?',
  doNotWorryYouCovered: 'Don’t worry, we’ve got you covered!',
  linkYourCardType: 'Link your card type – No card numbers, no personal info needed.',
  shopLikeAlways: 'Shop like always – See your rewards instantly at checkout.',
  compareAndDecide: 'Compare and decide – Easily choose the best card to maximize your rewards.',
  exclusivelyForUS: '*Exclusively for US users – try it today!',
  clientUninstallRespTitle: 'Thank You for Trying Karma!',
  clientUninstallRespTitle1: 'We appreciate you giving Karma a shot.',
  clientUninstallRespTitle2: 'While you’re off hunting for deals on your own, remember—we’re always here',
  clientUninstallRespTrackPriceDrop: 'Track price drops so you never overpay',
  clientUninstallRespHiddenDisc: 'Find hidden discounts and Cash Back',
  clientUninstallRespAlert: 'Alert you when items restock',
  clientUninstallRespShowBest: 'Show the best credit card perks at checkout',
  clientUninstallRespUSOnly: '*US only',
  clientUninstallRespWhantKeep: 'Want to keep saving?',
  otherTitle: 'We’d love to know\n why you’re leaving!',
  noRelevantDealsInMyFavedStoresTitle: 'We get it, some stores don’t always\n have discounts.',
  theKbuttonWasInMyWayTitle: 'You can move or minimize\n it in settings',
  iUseOtherShoppingExtensionsTitle: 'We respect the hustle\n saving money is the goal!',
  couponsAndPromosHub: 'Coupons and Promos Hub',
  weLoveToKnowYou: 'We’d love to get to know you better',
  takesLessThanMinute: 'Takes less than a minute, and helps us improve. Your answers stay private—promise.',
  skip: 'Skip',
  nonBinary: 'Non-binary',
  embeddedLoyaltyLearnMoreBtn: 'Learn more',
  embeddedLoyaltyStartTodayBtn: 'Start Today',
  embeddedLoyaltyGetStartedTitle: 'Get Started Today',
  embeddedLoyaltyGetStartedDescription:
    'Don’t miss the chance to transform your customer experience. Join the brands leveraging Karma’s White-Label Embedded Loyalty Platform to build lasting relationships and drive growth.',
  embeddedLoyaltyGetStartedBtn: 'Contact Us',
  embeddedLoyaltyHeader: "Elevate Your Banking Ecosystem with Karma's Loyalty Solution",
  embeddedLoyaltyHeaderDescription:
    'Karma’s <1>white-label embedded loyalty platform</1> positions your bank as the leader in delivering personalized cashback, rewards, and coupon opportunities for your customers whenever they shop – meeting their growing demand for <1>convenience, value, and engagement</1>, while ensuring that your brand is always <1>front and center</1>.',

  embeddedLoyaltyRewards: 'Empowering Banks to Deliver Seamless Rewards With Every Purchase',
  embeddedLoyaltyRewardsDescription:
    'Transform customer interactions into meaningful experiences while enhancing brand loyalty and driving valuable engagements.',
  embeddedLoyaltyChooseKarmaTitle: 'Why Choose Karma’s\n White-Label Loyalty Platform?',
  embeddedLoyaltyChooseKarmaDescription:
    'Our platform is built to meet the highest industry standards, fitting naturally into your ecosystem while keeping your brand in the forefront.',
  embeddedLoyaltyFeaturesTitle: 'Key Features & Benefits',
  embeddedLoyaltyAllFeaturesBtn: 'View all of our features',
  viewAllFeatures: 'View All Features',

  embeddedLoyaltyWhatSetsTitle: 'What Sets Us Apart?',
  embeddedLoyaltyWhatSetsDescription:
    'Unlike other solutions, Karma’s platform is designed to seamlessly blend into your brand experience. By focusing on ease of use and advanced technology, we help you foster deeper connections with your customers, ensuring loyalty programs become a natural extension of your business.',

  embeddedLoyaltyPlatformCaption: 'Effortless Integration for Banks',
  embeddedLoyaltyPlatformDescription:
    'Karma’s platform fits naturally into your ecosystem, offering a turnkey solution that minimizes technical complexity.',
  embeddedLoyaltyPlatformCaption2: 'Boost Brand Loyalty with White-Label Solutions',
  embeddedLoyaltyPlatformDescription2:
    'Keep your brand front and center. Karma ensures that every interaction reflects your identity, strengthening customer trust and loyalty.',
  embeddedLoyaltyPlatformCaption3: 'Bank-Grade Security and Compliance',
  embeddedLoyaltyPlatformDescription3:
    'Built to meet the highest industry standards, Karma’s platform ensures complete compliance with PCI and SOC certifications.',

  embeddedLoyaltyFeaturesTitle1: 'Streamlined Payment Autofill',
  embeddedLoyaltyFeaturesDescription1:
    'Simplify transactions with auto-filled payment details, keeping your card “top-of-wallet”. This feature minimizes checkout friction, ensuring your card is the preferred choice every time.',
  embeddedLoyaltyFeaturesTitle2: 'Upsell & Cross Sell Financial Products',
  embeddedLoyaltyFeaturesDescription2:
    'Easily offer your customers new financial products such as virtual cards, installments, new (issuance) credit card offers, savings accounts, or other bank products directly from the branded browser widget - live exactly when needed.',
  embeddedLoyaltyFeaturesTitle3: 'Earn & Redeem Points at Checkout',
  embeddedLoyaltyFeaturesDescription3:
    'Allow customers to seamlessly use their loyalty points as payment, enhancing the value of your rewards program at checkout. Customers can redeem points directly during their shopping journey, encouraging frequent card usage and building deeper loyalty.',
  embeddedLoyaltyFeaturesTitle4: 'Custom Shopping Portals & Offer Walls',
  embeddedLoyaltyFeaturesDescription4:
    'Offer your customers an intuitive shopping directory with exclusive deals from more than 100,000 global merchants, including travel and even meals. Whether through pre-configured solutions or customized integrations, Karma creates a hub for savings and rewards tailored to your brand, which can be hosted directly in your banking app, customer account page or behind a dedicated URL.',
  embeddedLoyaltyFeaturesTitle5: 'Targeted Cashback Offers & Notifications',
  embeddedLoyaltyFeaturesDescription5:
    'Delight customers with timely cashback notifications while they shop online. Karma’s platform presents offers at critical points in the purchase journey, increasing conversions and satisfaction. Notify customers via email, text or push notifications of price reductions or back-in-stock items for saved products and shopping lists that your customers have saved and curated.',
  embeddedLoyaltyResultsTitle: 'We Drive Results.',
  embeddedLoyaltyResultsDescription: 'Here’s how:',

  embeddedLoyaltyResultsCaption1: 'Comprehensive Merchant Network',
  embeddedLoyaltyResultsDescription1:
    'Access offers from a vast affiliate network, connecting your customers to over 100,000 global merchants.',

  embeddedLoyaltyResultsCaption2: 'Increased Engagement and Revenue',
  embeddedLoyaltyResultsDescription2:
    'By embedding rewards into your ecosystem, customers are incentivized to shop, increasing program adoption and driving incremental revenue.',

  embeddedLoyaltyResultsCaption3: 'Enhanced Customer Retention',
  embeddedLoyaltyResultsDescription3:
    'Offering meaningful savings and rewards builds loyalty, ensuring your customers stay engaged with your services.',
  embeddedLoyalty: 'Embedded Loyalty',
  headerEmbeddedLoyalty: 'Karma | Embedded Loyalty',
  headerSwe: 'Karma | SWE',
  gotKarmaStep1Title: 'Tap the <1/> on the left of <2/> the address bar. ',
  gotKarmaStep1Description: 'This is where all the magic is hidden.',
  gotKarmaStep2Title: 'Select ‘Manage Extensions’ <1/>',
  gotKarmaStep2Description: 'You’re getting warmer...',
  gotKarmaStep3Title: 'Toggle on ‘Karma’ <1/>',
  gotKarmaStep3Description: 'You found us! Now turn us on.',
  gotKarmaStep4Title: 'Tap <1/>',
  gotKarmaStep4Description: 'Just grant access - you’re so close!',
  gotKarmaStep5Title: 'Pick ‘Always Allow’ <1/>',
  gotKarmaStep5Description: 'Karma will make sure you always get the best deal.',
  gotKarmaStep6Title: 'Pick ‘Always Allow On Every Website’',
  gotKarmaStep6Description: 'Karma will find you the lowest prices everywhere.',
  downloadKarma: 'Download Karma!',
  sweQuestion1: 'How do I get the mobile extension?',
  sweAnswer1:
    'To enable the mobile extension, you have to start by downloading the app. Once you had that, just go into Safari, activate Karma, and grant access! For a more detailed explanation - look right above 🙂.',
  sweQuestion2: 'How does the Safari extension work?',
  sweAnswer2:
    "Karma automatically works in the background while you shop. It's a smart shopping companion that searches the web for coupons, deals, and lower prices. If you tell Karma what you're interested in, it will know to keep you in the loop on that specific item or offer.",
  sweQuestion3: 'Why do I need the Karma App to use the Safari Extension?',
  sweAnswer3:
    "Like other mobile extensions, the Safari extension is powered by the Karma App. They are bundled together in one download. So, if you already have the app, you're a step ahead!",
  sweQuestion4: 'Is the mobile extension available for Android?',
  sweAnswer4:
    "The mobile extension isn't available for Android yet, but the Karma App is! Get it in the Google Play Store now!",
  sweQuestion5: "Is my data secure on Karma's Safari extension?",
  sweAnswer5:
    'We take your privacy and security extremely seriously. Read more about what we do to keep your information safe.',

  sweScanBoxHeaderTitle: 'Karma for iPhone',
  sweScanBoxHeaderDescription:
    'The an all-in-one shopping assistant that automatically saves you time and money - now right at the tip of your fingers.',
  sweScanBoxTitle: 'Get Started on Mobile Safari',
  sweScanBoxDescription: 'Our extension is available exclusively in Mobile Safari.',
  sweScanBoxOpenSafari: 'Open this page in Safari on your iPhone.',
  sweScanBoxScanTheQrCode: 'Scan the QR code below to download the Karma app and activate the extension.',
  sweScanBoxOpenCamera: 'Open your camera on your iPhone to scan QR code.',
  stepsToSavingTitle: 'Got Karma?\n Let’s Walk You Through The Steps to Savings',
  discoverTopPicks: 'Discover Top Picks',
  topPicksAt: 'Top Picks at {{brand}}',
  games: 'Games',

  scheduleADemo: 'Schedule a demo',
  partnershipsReadyToShopTitle: 'Reach Millions of\nReady-to-Shop Users',
  partnershipsReadyToShopDescription: 'Tap into our engaged audience and drive real results.\nLet’s grow together.',
  partnershipsStat1Title: 'Shoppers',
  partnershipsStat2Title: 'Saved Items',
  partnershipsStat3Title: 'Newsletter Subscribers',

  partnershipsTurnShoppersTitle: 'Turn Shoppers into Buyers',
  partnershipsTurnShoppers1Title: '500K daily active users',
  partnershipsTurnShoppers3Title: 'Top Geos: US, UK, EU, CA, APAC',
  partnershipsTurnShoppers4Title: '85% of shoppers plan their next\n purchase with us',
  partnershipsTurnShoppers5Title: '$185 AOV',
  partnershipsTurnShoppers6Title: '200K+ partnered brands',

  partnershipsStrategicTitle: 'Strategic Brand Placements',
  partnershipsStrategicCaption1: 'Email Newsletter',
  partnershipsStrategicCaption2: 'Email Banner',
  partnershipsStrategicCaption3: 'Daily Featured',
  partnershipsStrategicCaption4: 'Trending Offers',
  partnershipsStrategicCaption5: 'Blog Content',
  partnershipsStrategicCaption6: 'Popular Stores',

  partnershipsExplorerTitle: 'Explore Our Case Studies',
  caseStudyTravelTitle: 'Travel',
  caseStudyTravelDescription:
    'Travel shoppers consistently generate some of the highest AOVs in ecommerce, with 65% of all bookings expected to happen online by 2026.',
  caseStudyLuxuryTitle: 'Luxury',
  caseStudyLuxuryDescription:
    'Millennials and Gen Z now drive most of the growth in luxury and are expected to represent up to 80% of global purchases by 2030.',
  caseStudyTechTitle: 'Tech',
  caseStudyTechDescription:
    'Savvy products means savvy shoppers. Electronics consumers compare hard, spend big, and respond strongly to well-timed offers.',
  caseStudyBeautyTitle: 'Beauty',
  caseStudyBeautyDescription:
    'Beauty shoppers are highly engaged, mobile-first, and influenced by social content - making this one of the most dynamic categories in ecommerce.',
  caseStudyHomeTitle: 'Home',
  caseStudyHomeDescription: 'High-consideration purchases + high AOV = every incremental sale counts.',
  caseStudyMarketplaceTitle: 'Marketplace',
  caseStudyMarketplaceDescription:
    'Around 72% of global ecommerce revenue now flows through marketplaces - brands that stand out here win visibility and scale.',
  caseStudyPetsTitle: 'Pets',
  caseStudyPetsDescription:
    'Loyalty-driven buyers who return again and again - pet owners show some of the highest repeat purchase rates across categories.',
  caseStudySportsOutdoorsTitle: 'Sports & Outdoors',
  caseStudySportsOutdoorsDescription:
    'Fitness-driven shoppers are mission-oriented and conversion-ready. Engagement spikes during key seasonal moments and product drops.',
  caseStudyFashionTitle: 'Fashion',
  caseStudyFashionDescription: '1 in 5 fashion buyers also purchase from Beauty or Home categories within 30 days.',
  partnershipsGetStartedTitle: 'Get Started Today',
  partnershipsGetStartedDescription:
    'Join a network of top brands leveraging Karma to reach millions of heavy shoppers.\n For more information contact <1>partnerships@karmanow.com</1>',
  getPromoCode: 'GET PROMO CODE',
  promoCodeCopied: 'Code copied',
  signIn: 'Sign In',
  couponCodesPromoCodesTitle: '{{Brand}} Promo Codes & Coupons',
  couponCodesPromoCodesCardTitle: 'Unlock Real-Time {{Brand}} Promo Codes - Verified Daily',
  couponCodesPromoCodesCardDescription:
    "Karma tracks, verifies, and refreshes promo codes in real time so you never miss a deal - whether you're shopping tech, home essentials, or the latest fashion finds. Bookmark this page and check back often for fresh savings that actually work. One click, instant value, no effort.",
  couponCodesHelpTitle: 'How Karma Helps You Find the Best {{Brand}} Promo Codes',
  couponCodesHelpCard1Title: 'Why Karma is the best place for real-time promo codes',
  couponCodesHelpCard1Description:
    "Karma tracks deals in real time, ensuring you see working promo codes the moment they're available. No endless searching, no expired links—just fresh, reliable discounts curated for shoppers who want to save smart with zero hassle.",
  couponCodesHelpCard2Title: 'How We Verify Codes',
  couponCodesHelpCard2Description:
    "Every promo code on Karma is tested before it's displayed, and continuously monitored throughout the day. If a code stops working, we remove it instantly so you never waste time trying expired or misleading coupons. Our verification system keeps your savings accurate, clean, and frustration-free.",
  couponCodesHelpCard3Title: 'How to Apply {{Brand}} Promo Codes (Step-by-Step)',
  couponCodesHelpCard3Step1: 'Browse this list and choose a code you want to use',
  couponCodesHelpCard3Step2: 'Click Get Code or Copy Code',
  couponCodesHelpCard3Step3: "You'll be taken to the shop automatically",
  couponCodesHelpCard3Step4: 'Add your items to cart',
  couponCodesHelpCard3Step5: 'Paste the code into the Promo/Discount box at checkout',
  couponCodesHelpCard3Step6: 'Enjoy instant savings on your order 🎉',
  couponCodesHelpCard4Title: 'Why {{Brand}} Promo Codes Expire Quickly',
  couponCodesHelpCard4Description:
    "Discounts are time-sensitive and heavily demand-driven. Many deals are tied to inventory, flash sales, or seller promotions, meaning they can disappear within hours. That's why Karma refreshes codes around the clock, to keep you ahead of the expiration clock.",
  couponCodesHelpCard5Title: 'Other Ways to Save Money on {{Brand}}',
  couponCodesHelpCard5Description:
    'Promo codes are just one part of the savings puzzle. With Karmanow, you can also save through:',
  couponCodesHelpCard5ListItem1: 'Price-drop alerts',
  couponCodesHelpCard5ListItem2: 'Back-in-stock notifications',
  couponCodesHelpCard5ListItem3: 'Cashback and coupon stacking opportunities',
  couponCodesHelpCard5ListItem4: 'Seasonal & holiday sale tracking',
  couponCodesHelpCard5Conclusion: 'More savings → Less effort → Smarter shopping.',
  couponCodesTodaysTopTitle: "Today's Top {{Brand}} Promo Codes",
  couponCodesTodaysTrendingPromoCodes: "Today's Trending Promo Codes",
  viewMoreDeals: 'View More Deals',
  neverMissADeal: 'Never miss a deal',
  subscribeToOurNewsletter: 'Subscribe to our newsletter and get notified about amazing discounts.',
  subscribing: 'Subscribing...',
  subscribe: 'Subscribe',
  newsletterSubscriptionSuccess: 'Successfully subscribed to newsletter!',
  newsletterSubscriptionError: 'Failed to subscribe. Please try again.',
  couponCodesQuestionsSubtitle: "Got questions about Karma? We've got answers.",
  couponCodesQuestionsQ1: 'How often are promo codes updated?',
  couponCodesQuestionsA1: 'We update this page daily to ensure you get the latest deals.',
  couponCodesQuestionsQ2: 'Can I use multiple promo codes?',
  couponCodesQuestionsA2:
    "Depends on the brand - some allow you to do so while others don't. But most coupons can be combined with other discounts!",
  couponCodesQuestionsQ3: 'Do promo codes expire?',
  couponCodesQuestionsA3: 'Yes, most codes have a limited time frame, so check the expiration date before using.',
  couponCodesQuestionsQ4: 'Is Karma free to use?',
  couponCodesQuestionsA4: '100% free — no sign-up required to browse codes or save money.',
  couponCodesQuestionsQ5: 'Are promo codes verified?',
  couponCodesQuestionsA5: 'Yes - Karmanow verifies codes in real time to eliminate dead or fake discounts.',
  verified: 'Verified',
  couponCodesShoppingTipsTitle: '{{Brand}} Shopping Tips',
  couponCodesShoppingTipsSubtitle: "Shopping at {{Brand}}? Here's how to save smarter:",
  couponCodesDiscountsOfDayTitle: 'What To Buy At {{Brand}} Now',
  couponCodesDiscountsOfDaySubtitle: 'Biggest Discounts of the Day',
  couponCodesDiscountsOfDayNeverMissADeal: 'Never miss a deal',
  couponCodesDiscountsOfDaySubscribeToOurNewsletter:
    'Subscribe to our newsletter and get notified about amazing discounts.',
  couponCodesDiscountsOfDaySubscribing: 'Subscribing...',
  couponCodesDiscountsOfDaySubscribe: 'Subscribe',
  couponCodesPopularBrandsTitle: 'Promo Codes From Other Popular Brands',
  couponCodesPopularBrandsSubtitle:
    'Looking for promo codes from other stores? Click on any brand to see the latest verified promo codes and savings.',
  headerKarmaEarn: 'Karma | Karma Earn',
  earnNowShopLater: 'Earn now. Shop later.',
  startEarningBtn: 'Start Earning!',
  startEarningDescription: 'Turn the things you already do into real rewards, with more ways to earn in one place.',
  giftCardSuccessTitle: "You're all set!",
  giftCardSuccessMessage: 'Your <strong>{{name}}</strong> gift card is on its way - check your inbox shortly.',
  giftCardErrorTitle: 'Something went wrong.',
  giftCardErrorMessage: "Please reach out to support and we'll get this sorted for you.",
};
